import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Divider,
  Avatar,
  Stack,
  Button,
  Collapse,
  Grid,
  Paper,
  IconButton,
  Tooltip,
  Popper,
  ListSubheader,
  ListItemButton,
  ClickAwayListener,
} from "@mui/material";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { RiDashboardLine, RiDashboardFill } from "react-icons/ri";
import { RiArchiveDrawerLine, RiArchiveDrawerFill } from "react-icons/ri";
import { RiGroupLine, RiGroupFill } from "react-icons/ri";
import { RiArchiveStackLine, RiArchiveStackFill } from "react-icons/ri";
import { RiBubbleChartLine, RiBubbleChartFill } from "react-icons/ri";
import { RiCornerDownRightLine } from "react-icons/ri";
import { RiAiGenerate } from "react-icons/ri";
import { RiChatVoiceLine,RiChatVoiceFill} from 'react-icons/ri';
import { RiGitMergeLine, RiGitMergeFill} from "react-icons/ri";
import { RiQuillPenLine, RiQuillPenFill } from "react-icons/ri";
import { RiLightbulbFlashFill, RiLightbulbFlashLine } from "react-icons/ri";
import { useAuth } from "../helpers/AuthProvider"; // Assuming this path is correct
import { nameRoleObj } from "../helpers/RoleHelper"; // Assuming this path is correct
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { RiLineChartLine, RiLineChartFill } from "react-icons/ri";
import { RiSendPlaneFill, RiSendPlaneLine } from "react-icons/ri";
// import { color } from "framer-motion"; // If not used, can be removed
import queryGraphql from "../helpers/ApiInterface";
// --- MINIMAL CHANGE: Export width constants for parent component to use ---
export const openDrawerWidth = 250;
export const collapsedDrawerWidth = 72;
// This constant is used internally for the toggle button position
const topSectionApproximateHeight = 180;


interface NavItem {
  id: string;
  text: string;
  icon: JSX.Element;
  clickedIcon: JSX.Element;
  nav: string;
  visibility: string[];
  items: NavItem[];
}
const navPaneListOriginal: NavItem[] = [
  {
    id: "overview",
    text: "Overview",
    icon: <RiDashboardLine />,
    clickedIcon: <RiDashboardFill />,
    nav: "/overview",
    visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"],
    items:[],
  },
  
  {
    id: "clusters",
    text: "Clusters",
    icon: <RiArchiveDrawerLine />,
    clickedIcon: <RiArchiveDrawerFill />,
    nav: "/clusters",
    visibility: ["cluster_owner", "application_owner", "idp_admin", "viewer"],
    items: [],
  },
  {
    id: "applications",
    text: "Applications",
    icon: <RiArchiveStackLine />,
    clickedIcon: <RiArchiveStackFill />,
    nav: "/applications",
    visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "viewer"],
    items: [],
  },
  {
    id: "services",
    text: "Services",
    icon: <RiBubbleChartLine />,
    clickedIcon: <RiBubbleChartFill />,
    nav: "/services",
    visibility: ["application_owner", "idp_admin", "developer", "viewer"],
    items: [],
  },
  // {
  //   id: "apis",
  //   text: "APIs",
  //   icon: <RiSendPlaneLine />,
  //   clickedIcon: <RiSendPlaneFill />,
  //   nav: "/apis",
  //   visibility: ["application_owner", "idp_admin", "developer", "viewer"],
  //   items: [],
  // },
  {
    id: "apis",
    text: "APIs ",
    icon: <RiSendPlaneLine />,
    clickedIcon: <RiSendPlaneFill />,
    nav: "/apis",
    visibility: [ "application_owner", "idp_admin", "developer", "viewer"],
    items:[
      { id: "apis-backend", text: "APIs Backend", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/apis", visibility: ["application_owner", "idp_admin", "developer", "viewer"], items: [] },
      { id: "apis-gateway", text: "APIs Gateway", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/apis-gateway", visibility: ["application_owner", "idp_admin", "developer", "viewer"], items: [] },
      { id: "apis-consumer-group", text: "Consumer Group", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/consumer-group", visibility: ["application_owner", "idp_admin", "developer", "viewer"], items: [] },
      { id: "apis-catalogue", text: "APIs Catalogue", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/integrations/custom-api-catalogue", visibility: ["application_owner", "idp_admin", "developer", "viewer"], items: [] }
    ],
  },
  {
    id: "insights",
    text: "Insights",
    icon: <RiLightbulbFlashLine />,
    clickedIcon: <RiLightbulbFlashFill />,
    nav: "/finops-dashboard",
    visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"],
    items:[
      { id: "insights-finops-dashboard", text: "FinOps", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/finops-dashboard", visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"], items: [] },
      { id: "insights-observability-dashboard", text: "Observability", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/observability-dashboard", visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"], items: [] }
    ],
  },
  {
    id: "aisolutions",
    text: "AI Solutions",
    icon: <RiAiGenerate />,
    clickedIcon: <RiQuillPenFill />, // Consider an AI-specific clicked icon
    nav: "",
    visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"],
    items:[
      { id: "aisolutions-aiagent", text: "AI Agent", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/aiagent", visibility: ["infrastructure_admin", "idp_admin","cluster_owner","application_owner", "developer","viewer"], items: [] },
      { id: "aisolutions-rag", text: "RAG", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/rag", visibility: ["infrastructure_admin", "idp_admin","application_owner", "developer", "viewer"], items: [] },
      { id: "aisolutions-finetuning", text: "Fine Tuning", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/finetuning", visibility: ["infrastructure_admin", "idp_admin","cluster_owner","application_owner", "developer", "viewer"], items: [] },
      { id: "aisolutions-notebooks", text: "Notebooks", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/notebooks", visibility: ["infrastructure_admin", "idp_admin","cluster_owner","application_owner", "developer", "viewer"], items: [] },
      { id: "aisolutions-aiverse", text: "Agentverse", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/aiverse", visibility: ["infrastructure_admin", "idp_admin","cluster_owner","application_owner", "developer", "viewer"], items: [] },
    ],
  },
  {
    id: "datasolutions",
    text: "Data Solutions",
    icon: <RiLineChartLine />,
    clickedIcon: <RiLineChartFill />,
    nav: "",
    visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"],
    items:[
      { id: "datasolutions-data-pipelines", text: "Data Pipelines", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/datasolutions/data-pipelines", visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"], items: [] },
      { id: "datasolutions-data-warehouses", text: "Data Warehouses", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/datasolutions/data-warehouses", visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"], items: [] },
      { id: "datasolutions-data-bi", text: "Analytics & BI", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/datasolutions/data-bi", visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"], items: [] },
      { id: "datasolutions-data-sources", text: "Data Sources", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/datasolutions/data-sources", visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"], items: [] },
      { id: "datasolutions-data-lakes", text: "Data Lakes", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/datasolutions/data-lakes", visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"], items: [] },
      { id: "datasolutions-data-zones", text: "Data Zones", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/datasolutions/data-zones", visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"], items: [] },
      { id: "datasolutions-data-scans", text: "Data Scans", icon: <RiDashboardLine/> , clickedIcon: <RiDashboardFill/> , nav: "/datasolutions/data-scans", visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin", "viewer"], items: [] }
    ],
  },
  {
    id: "integrations",
    text: "Integrations",
    icon: <RiGitMergeLine/>,
    clickedIcon: <RiGitMergeFill />,
    nav: "/integrations",
    visibility: ["idp_admin", "infrastructure_admin", "application_owner", "cluster_owner", "developer", "viewer"],
    items: [],
  },
  {
    id: "user-management",
    text: "User Management",
    icon: <RiGroupLine />,
    clickedIcon: <RiGroupFill />,
    nav: "/user-management",
    visibility: ["idp_admin", "viewer"],
    items: [],
  },
  {
    id: "requests",
    text: "Requests",
    icon: <RiCornerDownRightLine />, // Clicked icon was same, assuming intentional
    clickedIcon: <RiCornerDownRightLine />,
    nav: "",
    visibility: ["infrastructure_admin", "application_owner", "idp_admin", "viewer"],
    items: [
      { id: "requests-cluster", text: "Clusters", icon: <RiArchiveDrawerLine /> , clickedIcon: <RiArchiveDrawerFill /> , nav: "/requests/clusters", visibility: ["infrastructure_admin", "idp_admin", "viewer"], items: [] },
      { id: "requests-application", text: "Applications", icon: <RiArchiveStackLine /> , clickedIcon: <RiArchiveStackFill /> , nav: "/requests/applications", visibility: ["infrastructure_admin", "idp_admin", "viewer"], items: [] },
      { id: "requests-service", text: "Services", icon: <RiBubbleChartLine /> , clickedIcon: <RiBubbleChartFill /> , nav: "/requests/services", visibility: ["application_owner", "idp_admin", "viewer"], items: [] },
      { id: "requests-aiagent", text: "AI Agent", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/requests/aiagent", visibility: ["idp_admin", "infrastructure_admin", "viewer"], items: [] },
      { id: "requests-rag", text: "RAG", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/requests/rag", visibility: ["idp_admin", "infrastructure_admin", "viewer"], items: [] },
      { id: "requests-finetuning", text: "Fine Tuning", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/requests/finetuning", visibility: ["idp_admin", "infrastructure_admin", "viewer"], items: [] },
      { id: "requests-notebooks", text: "Notebooks", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/requests/notebooks", visibility: ["idp_admin", "infrastructure_admin", "viewer"], items: [] },
      { id: "requests-data-pipelines", text: "Data Pipelines", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/datasolutions/requests/data-pipelines", visibility: ["idp_admin", "infrastructure_admin", "viewer"], items: [] },
      
      { id: "requests-data-warehouses", text: "Data Warehouses", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/datasolutions/requests/data-warehouses", visibility: ["idp_admin", "infrastructure_admin", "viewer"], items: [] },
      { id: "requests-data-bi", text: "Analytics & BI", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/datasolutions/requests/data-bi", visibility: ["idp_admin", "infrastructure_admin", "viewer"], items: [] },
      { id: "requests-data-sources", text: "Data Sources", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/datasolutions/requests/data-sources", visibility: ["idp_admin", "infrastructure_admin", "viewer"], items: [] },
      { id: "requests-data-lakes", text: "Data Lakes", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/datasolutions/requests/data-lakes", visibility: ["idp_admin", "infrastructure_admin", "viewer"], items: [] },
      { id: "requests-data-zones", text: "Data Zones", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/datasolutions/requests/data-zones", visibility: ["idp_admin", "infrastructure_admin", "viewer"], items: [] },
      { id: "requests-data-scans", text: "Data Scans", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/datasolutions/requests/data-scans", visibility: ["idp_admin", "infrastructure_admin", "viewer"], items: [] },
      { id: "requests-apis", text: "APIs Backend", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/apis/requests", visibility: ["idp_admin", "infrastructure_admin","application_owner", "viewer"], items: [] },
      { id: "requests-apis-gateway", text: "APIs Gateway", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/apis-gateway/requests", visibility: ["idp_admin", "infrastructure_admin","application_owner", "viewer"], items: [] },
      { id: "requests-consumer-group", text: "Consumer Group", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/consumer-group/requests", visibility: ["idp_admin", "infrastructure_admin","application_owner", "viewer"], items: [] },
    ],
  },
];

interface HomepageProps {
  index: string;
  // --- MINIMAL CHANGE: Add optional onStateChange prop to report state upwards ---
  onStateChange?: (isOpen: boolean) => void;
}

const simpleTooltipSx = {
  bgcolor: '#FFFFFF',
  color: '#212121',
  borderRadius: '6px',
  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
  padding: '6px 10px',
  fontSize: '13px',
  fontFamily: 'Gilroy-Regular',
  border: '1px solid #E0E0E0',
};
const simpleTooltipPopperProps = {
  disablePortal: false,
  modifiers: [ { name: 'offset', options: { offset: [0, 10] } } ],
};


const MainDrawer: React.FC<HomepageProps> = ({
  index,
  // --- MINIMAL CHANGE: Destructure the new prop ---
  onStateChange
}) => {
  const { user, logoutUser } = useAuth();
  const navigate = useNavigate();
  const [integrations, setIntegrations] = useState<any>({});
  // Internal state management for drawer open/closed
  const [isDrawerOpen, setIsDrawerOpen] = useState(() => {
    const storedState = localStorage.getItem('isFaradayDrawerOpen');
    return storedState !== null ? JSON.parse(storedState) : true;
  });

  // --- MINIMAL CHANGE: useEffect to report initial and subsequent state changes ---
  useEffect(() => {
    // Report the state whenever it changes or on initial mount
    if (onStateChange) {
      onStateChange(isDrawerOpen);
    }
    // Persist to localStorage (existing logic)
    localStorage.setItem('isFaradayDrawerOpen', JSON.stringify(isDrawerOpen));
  }, [isDrawerOpen, onStateChange]); // Add onStateChange to dependency array

  React.useEffect(() =>{
    const fetchData = async () => {
      try {
        const data = await queryGraphql(`
           query CostAgent {
              getIntegrations {
                costAgent {
                  datasetId
                  enabled
                  projectId
                  serviceAccountName
                  tableId
                  updatedAt
                }
                checkov {
                  enabled
                }
                kyverno {
                  enabled
                }
                grafana{
                  enabled
                }
                prometheus {
                  enabled
                }
              }
            }
          `, 
            {}
            );
        if(data?.getIntegrations){
         await setIntegrations(data?.getIntegrations);
          console.log(integrations);
        }
        }
        catch(e){
      console.log(e);
        }
  }
  fetchData();
  },[]);

  const filteredNavPaneList: NavItem[] = React.useMemo(() => {
    if (!user || !user.roles) return [];

    // Initial role-based filtering for top-level items
    let list = navPaneListOriginal.filter((element: NavItem) =>
      element.visibility.some((e: any) => user.roles.includes(e))
    );

    // Map and filter sub-items with new conditions
    list = list.map((element: NavItem) => {
      // First, filter sub-items by role
      let subItems = element.items.filter((el: NavItem) =>
        el.visibility.some((e: any) => user.roles.includes(e))
      );

      // Additional filtering for specific dashboard sub-items based on integrations
      if (element.id === "dashboard") {
        subItems = subItems.filter((subEl: NavItem) => {
          if (subEl.id === "dashboard-finops-dashboard") {
            // Show "Cost" if costAgent is enabled
            return integrations?.costAgent?.enabled === true;
          }
          if (subEl.id === "dashboard-observability-dashboard") {
            // Show "Observability" if prometheus is enabled (as per your GraphQL query)
            return integrations?.grafana?.enabled === true;
          }
          // Keep any other dashboard sub-items that passed the role filter
          return true;
        });
      }

      return {
        ...element,
        items: subItems,
      };
    });

    return list;
  }, [user, integrations]);
  // const filteredNavPaneList: NavItem[] = React.useMemo(() => {
  //    if (!user || !user.roles) return [];
  //    let list = navPaneListOriginal.filter((element: NavItem) =>
  //      element.visibility.some((e: any) => user.roles.includes(e))
  //    );
  //    list = list.map((element: NavItem) => ({
  //      ...element,
  //      items: element.items.filter((el: NavItem) =>
  //        el.visibility.some((e: any) => user.roles.includes(e))
  //      ),
  //    }));
  //    return list;
  // }, [user]);

  const [nestedOpen, setNestedOpen] = useState<any>(
    // Initialize based on the initial index prop
    () => {
      if (index && index.includes("-")) {
        const parentId = index.split("-")[0];
        return { [parentId]: true };
      }
      return {};
    }
  );
  const [selectedMenu, setSelectedMenu] = useState(index);

  // Effect to open parent of selected index if index prop changes,
  // without closing other manually opened nested menus.
  useEffect(() => {
    if (index && index.includes("-")) {
      const parentId = index.split("-")[0];
      setNestedOpen((prev: Record<string, boolean>) => {
        // If the parent is not already marked as open, open it.
        if (!prev[parentId]) {
          return { ...prev, [parentId]: true };
        }
        return prev; // No change needed if parent already open or not relevant
      });
    }
    // Update selectedMenu when index prop changes
    setSelectedMenu(index);
  }, [index]);

  const [popperAnchorEl, setPopperAnchorEl] = useState<null | HTMLElement>(null);
  const [openPopperMenuId, setOpenPopperMenuId] = useState<null | string>(null);
  const popperTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  
  // Ref for the scrollable list container
  const scrollableListRef = useRef<HTMLDivElement>(null);

  const handleNestedClick = (name: any) => {
     if (isDrawerOpen) {
      setNestedOpen((prev: any) => ({ ...prev, [name]: !prev[name] }));
    }
  };

  const handleMenuSelect = (key: any) => {
    setSelectedMenu(key);
  };

  // Function to save scroll position
  const saveScrollPosition = () => {
    if (scrollableListRef.current) {
      sessionStorage.setItem('mainDrawerScrollTop', scrollableListRef.current.scrollTop.toString());
    }
  };

  // Effect to restore scroll position on mount or when user/drawer state changes
  useEffect(() => {
    const savedScrollTop = sessionStorage.getItem('mainDrawerScrollTop');
    if (savedScrollTop && scrollableListRef.current) {
      // Restore scroll position after a short delay to ensure the list is rendered
      setTimeout(() => {
        if (scrollableListRef.current) scrollableListRef.current.scrollTop = parseInt(savedScrollTop, 10);
      }, 0);
    }
  }, [user, isDrawerOpen]); // Rerun if user changes or drawer opens/closes, ensuring list is visible

  // Internal toggle function - UI and core logic unchanged
  const toggleDrawer = () => {
    // The useEffect above will automatically call onStateChange when isDrawerOpen changes
    const nextDrawerState = !isDrawerOpen;
    setIsDrawerOpen(nextDrawerState);
    // If collapsing the drawer, clear all nested open states for a cleaner look when collapsed.
    // Preserved nestedOpen state will be restored from localStorage or re-evaluated by index effect upon re-expansion.
    if (!nextDrawerState) { // If the drawer is being closed
        setNestedOpen({}); // Visually close all nested items
    } // If expanding, the useEffect for `index` and persisted state will handle opening.
    setPopperAnchorEl(null);
    setOpenPopperMenuId(null);
  };

  // Internal width calculation - UI unchanged
  const currentDrawerWidth = isDrawerOpen ? openDrawerWidth : collapsedDrawerWidth;

  const handleParentMenuMouseEnter = (event: React.MouseEvent<HTMLElement>, menu: NavItem) => {
    if (openPopperMenuId === menu.id) {
        if (popperTimeoutRef.current) {
            clearTimeout(popperTimeoutRef.current);
            popperTimeoutRef.current = null;
        }
    }
    if (!isDrawerOpen && menu.items.length > 0) {
        setPopperAnchorEl(event.currentTarget);
        setOpenPopperMenuId(menu.id);
    }
  };

  const handleParentMenuMouseLeave = () => {
     if (popperTimeoutRef.current) {
        clearTimeout(popperTimeoutRef.current);
     }
    popperTimeoutRef.current = setTimeout(() => {
      closePopper();
    }, 150);
  };

  const handlePopperMouseEnter = () => {
    if (popperTimeoutRef.current) {
      clearTimeout(popperTimeoutRef.current);
      popperTimeoutRef.current = null;
    }
  };

  const handlePopperMouseLeave = () => {
     if (popperTimeoutRef.current) {
        clearTimeout(popperTimeoutRef.current);
     }
    popperTimeoutRef.current = setTimeout(() => {
      closePopper();
    }, 150);
  };

  const closePopper = () => {
    if (popperTimeoutRef.current) {
       clearTimeout(popperTimeoutRef.current);
       popperTimeoutRef.current = null;
    }
    if (popperAnchorEl !== null || openPopperMenuId !== null) {
        setPopperAnchorEl(null);
        setOpenPopperMenuId(null);
    }
  }

  const currentOpenPopperMenu = openPopperMenuId ? filteredNavPaneList.find((m: NavItem) => m.id === openPopperMenuId) : null;

  return (
    <>
      <Drawer
         variant="permanent" // This drawer is always permanent
         sx={{
          width: currentDrawerWidth, // Uses internal calculation
          flexShrink: 0,
          height: "100vh",
          [`& .MuiDrawer-paper`]: {
            width: currentDrawerWidth, // Uses internal calculation
            boxSizing: "border-box",
            backgroundColor: "black",
            color: "white",
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
            transition: (theme) => theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          },
        }}
      >
        {/* Top Section: Logo and User Details - UI Unchanged */}
        <Box sx={{ paddingBottom: isDrawerOpen ? 0 : '8px' }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: isDrawerOpen ? "flex-start" : "center",
              paddingLeft: isDrawerOpen ? 2 : 0,
              mt: "12px",
              minHeight: "54px",
              gap: isDrawerOpen ? 1 : 0,
            }}
          >

            {isDrawerOpen?
            <img
              src="/assets/intellicore-transparent-white.png" // Ensure this path is correct
              alt="Faraday Logo"
              style={{
                  width:"125px" ,
                  height:"27px" ,
                  marginLeft:10,
               }}
            />
            :
            <img
              src="/assets/intellicore-logo-only.png" // Ensure this path is correct
              alt="Faraday Logo"
              style={{
                  width:"27px",
                  height:"27px",
                  marginLeft: 0,
               }}
            />
            }
            
            {/* {isDrawerOpen && (
              <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" noWrap>
                Intellicore
              </Typography>
            )} */}
          </Box>

          {user && (
             <>
              {isDrawerOpen ? (
                 <>
                  <Stack direction="column" marginTop="-20px">
                    <Avatar
                      src={user.googleProfilePicture}
                      alt={user.name || "User Avatar"}
                      sx={{
                        width: "56px", height: "56px", marginLeft: "24px",
                        position: "relative", top: 39, border: "3px solid black",
                      }}
                    />
                    <Box
                      sx={{
                        backgroundColor: "#212121", borderRadius: "8px", padding: "10px",
                        margin: "20px", display: "flex", flexDirection: "column"
                      }}
                    >
                      <Typography fontFamily="Gilroy-Bold" fontSize="14px" marginTop="10px" marginLeft="4px">
                        {user.name}
                      </Typography>
                      <Grid container gap={0.5} mt={0.5}>
                        {user.roles?.map((e: string) => (
                          <Grid item key={e}>
                            <Paper
                              elevation={3}
                              sx={{ borderRadius: 10, backgroundColor: "#555", padding: "2px 0px" }}
                            >
                              <Box px={1}>
                                <Typography fontSize="10px" fontFamily="Gilroy-Regular" color="#fff">
                                  {nameRoleObj[e] || e}
                                </Typography>
                              </Box>
                            </Paper>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  </Stack>
                  {/* <Divider color="#181818" sx={{ mt: "8px", mb: "8px", mx: "16px" }} /> */}
                </>

              ) : (
                 <Box sx={{ display: 'flex', justifyContent: 'center', py: 1, mt: 1 }}>
                    <Tooltip
                        title={user.name || "User"}
                        placement="right"
                        componentsProps={{
                           tooltip: { sx: simpleTooltipSx },
                           popper: { ...simpleTooltipPopperProps }
                        }}
                        >
                        <Avatar
                            src={user.googleProfilePicture} alt={user.name || "User Avatar"}
                            sx={{ width: "40px", height: "40px", border: '2px solid #444' }}
                        />
                    </Tooltip>
                 </Box>
              )}
            </>
          )}
        </Box>
        <Box sx={{ borderBottom: '1px solid #212121', mt: (isDrawerOpen && user) ? 0 : 1, mb:1 }}/>


        {/* Scrollable Navigation List - UI Unchanged */}
        <Box ref={scrollableListRef} sx={{ overflowY: "auto", flex: 1 }}>
          <List sx={{ px: isDrawerOpen ? "8px" : "4px", mx: isDrawerOpen ? "8px" : "4px" , my: isDrawerOpen ? "0px":"5vh"}}>
            {filteredNavPaneList.map((menu: NavItem) => (
              <React.Fragment key={menu.id}>
                <Tooltip
                  title={(isDrawerOpen || menu.items.length > 0) ? "" : menu.text}
                  placement="right"
                  componentsProps={!isDrawerOpen && menu.items.length === 0 ? {
                     tooltip: { sx: simpleTooltipSx },
                     popper: { ...simpleTooltipPopperProps }
                  } : {}}
                >
                  <ListItem
                     component="div"
                     onMouseEnter={(e) => handleParentMenuMouseEnter(e, menu)}
                     onMouseLeave={handleParentMenuMouseLeave}
                     onClick={() => {
                       if (menu.items.length > 0 && isDrawerOpen) {
                        handleNestedClick(menu.id);
                        saveScrollPosition(); // Save scroll on interaction
                      } else if (menu.items.length === 0) {
                        handleMenuSelect(menu.id);
                        saveScrollPosition(); // Save scroll before navigation
                        if (menu.nav) navigate(menu.nav);
                        closePopper();
                      }
                     }}
                     sx={{
                       cursor: "pointer", borderRadius: "8px",
                      backgroundColor: menu.id === selectedMenu ? "#fff" : "transparent",
                      color: menu.id === selectedMenu ? "#000" : "#fff",
                      mb: 1, justifyContent: isDrawerOpen ? "flex-start" : "center",
                      padding: isDrawerOpen ? "8px 16px" : "12px 0",
                      '&:hover': {
                          backgroundColor: openPopperMenuId === menu.id ? undefined : (menu.id === selectedMenu ? "#eee" : (isDrawerOpen ? "#212121" : "#333")),
                      }
                     }}
                     aria-describedby={openPopperMenuId === menu.id ? `popper-${menu.id}` : undefined}
                  >
                    <ListItemIcon
                      sx={{
                          color: menu.id === selectedMenu ? "inherit" : "#A2A2A2",
                          minWidth: "unset", mr: isDrawerOpen ? 1 : 0, justifyContent: 'center',
                      }}>
                      {menu.id === selectedMenu && menu.clickedIcon ? menu.clickedIcon : menu.icon}
                    </ListItemIcon>
                    {isDrawerOpen && (
                      <ListItemText>
  <Typography
    fontFamily={menu.id === selectedMenu ? "Gilroy-Bold" : "Gilroy-Regular"}
    fontSize="14px" // This is the same for both, so no condition needed
    color={menu.id === selectedMenu ? "#000" : "#A2A2A2"}
  >
    {menu.text}
  </Typography>
</ListItemText>
                    )}
                    {isDrawerOpen && menu.items.length > 0 && (nestedOpen[menu.id] ? <ExpandLess /> : <ExpandMore />)}
                  </ListItem>
                </Tooltip>

                 {isDrawerOpen && menu.items.length > 0 && (
                  <Collapse in={nestedOpen[menu.id]} timeout="auto" unmountOnExit>
                    <List sx={{ mx: 2, pl: 2 }}>
                      {menu.items.map((item: NavItem) => (
                       <Tooltip title="" placement="right" key={item.id} >
                        <ListItem
                          onClick={() => {
                            handleMenuSelect(item.id);
                            saveScrollPosition(); // Save scroll before navigation
                            if (item.nav) navigate(item.nav);
                          }}
                          sx={{
                            cursor: "pointer", borderRadius: "8px",
                            backgroundColor: item.id === selectedMenu ? "#ffffff" : "transparent",
                            color: item.id === selectedMenu ? "#000" : "#fff",
                            mb: 0.5, paddingLeft: '16px',
                             '&:hover': { backgroundColor: item.id === selectedMenu ? "#eee" : "#212121" }
                          }}
                        >
                          {isDrawerOpen && (
                             <ListItemText>
  <Typography
    fontFamily={item.id === selectedMenu ? "Gilroy-Bold" : "Gilroy-Regular"}
    fontSize="14px" // This is the same for both, so no condition needed
    color={item.id === selectedMenu ? "#000" : "#A2A2A2"}
  >
    {item.text}
  </Typography>
</ListItemText>
                              // <ListItemText>
                              // <Typography fontFamily="Gilroy-Bold" fontSize="14px">{item.text}</Typography>
                              // </ListItemText>
                          )}
                        </ListItem>
                        </Tooltip>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>
        </Box>

        {/* Bottom Section: Sign Out Button - UI Unchanged */}
        <Box sx={{ marginTop: 'auto', padding: isDrawerOpen ? '0 8px 8px 8px' : '8px 4px' }}>
          {isDrawerOpen && <Divider sx={{ bgcolor: "#212121", mx: "8px", mb:1 }} />}
          <Tooltip
              title={isDrawerOpen ? "" : "Sign Out"}
              placement="right"
              componentsProps={!isDrawerOpen ? {
                 tooltip: { sx: simpleTooltipSx },
                 popper: { ...simpleTooltipPopperProps }
              } : {}}
          >
              <Button
                fullWidth variant="text"
                sx={{
                    backgroundColor: "black", color: "white", display: "flex",
                    justifyContent: isDrawerOpen ? "flex-start" : "center",
                    alignItems: "center",
                    "&:hover": { backgroundColor: "#212121", color: "white" },
                    textTransform: "none", padding: isDrawerOpen ? "12px 16px" : "12px 0",
                }}
                onClick={() => { 
                  saveScrollPosition(); // Save scroll before logging out
                  logoutUser(); 
                  navigate("/login"); 
                }}
              >
                <RiLogoutCircleRLine size={isDrawerOpen? 20 : 24} />
                {isDrawerOpen && (
                    <Typography fontFamily="Gilroy-Regular" fontSize="14px" ml="8px" color="#FFFFFF">
                    Sign Out
                    </Typography>
                )}
              </Button>
          </Tooltip>
        </Box>
      </Drawer>

      {/* Drawer Toggle Button (Internal to MainDrawer) - UI Unchanged */}
      <Box
        sx={{
          position: 'fixed',
          top: topSectionApproximateHeight - 20, // Uses internal constant
          left: currentDrawerWidth, // Uses internal calculation
          transform: 'translateX(-50%) translateY(-50%)',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: '#FFFFFF',
          borderRadius: '50%',
          boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
          transition: 'left 0.2s ease-in-out', // Matches drawer width transition timing
        }}
      >
          <IconButton
            onClick={toggleDrawer} // Internal toggle function
            sx={{ padding: '8px' }}
          >
             {isDrawerOpen ? (
              <img
                src="/assets/arrow-left-s-line.svg" // Ensure this path is correct
                alt="Collapse menu"
                style={{ width: 14, height: 14, display: 'block' }}
              />
            ) : (
              <img
                src="/assets/arrow-right-s-line.svg" // Ensure this path is correct
                alt="Expand menu"
                style={{ width: 14, height: 14, display: 'block' }}
              />
            )}
          </IconButton>
      </Box>

      {/* Popper (Internal to MainDrawer) - UI Unchanged */}
      {currentOpenPopperMenu && (
        <Popper
          id={popperAnchorEl ? `popper-${openPopperMenuId}` : undefined}
          open={Boolean(popperAnchorEl) && !isDrawerOpen && openPopperMenuId === currentOpenPopperMenu.id}
          anchorEl={popperAnchorEl}
          role="tooltip"
          placement="right"
          modifiers={[ { name: 'offset', options: { offset: [10, 0] } } ]}
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
          onMouseEnter={handlePopperMouseEnter}
          onMouseLeave={handlePopperMouseLeave}
        >
              <Paper sx={{
                   backgroundColor: '#FFFFFF',
                  color: '#212121',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
                  minWidth: 180,
                  border: '1px solid #E0E0E0',
               }}>
                <ClickAwayListener onClickAway={closePopper}>
                   <List dense component="nav" subheader={
                    <ListSubheader component="div" sx={{
                        bgcolor: 'transparent', color: '#333333', fontFamily: 'Gilroy-SemiBold',
                        fontSize: '13px', lineHeight: '2.5', textTransform: 'uppercase', pl: 2
                    }}>
                      {currentOpenPopperMenu.text}
                    </ListSubheader>
                  }>
                    {currentOpenPopperMenu.items.map((subItem: NavItem) => (
                      <ListItemButton
                        key={subItem.id}
                        selected={subItem.id === selectedMenu}
                        onClick={() => {
                          handleMenuSelect(subItem.id);
                          saveScrollPosition(); // Save scroll before navigation from popper
                          if (subItem.nav) navigate(subItem.nav);
                          closePopper();
                        }}
                        sx={{
                          pl: 2, pr:2, py: 0.75,
                          '&.Mui-selected': { backgroundColor: '#f0f0f0', color: '#000000', '&:hover': { backgroundColor: '#e0e0e0' } },
                          '&:hover': { backgroundColor: '#f5f5f5' }
                        }}
                      >
                        <ListItemText
                          primary={subItem.text}
                          primaryTypographyProps={{
                            fontSize: '14px', fontFamily: 'Gilroy-Regular',
                            color: subItem.id === selectedMenu ? '#000000' : '#333333'
                          }}
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </ClickAwayListener>
              </Paper>
        </Popper>
      )}
    </>
  );
};
export default MainDrawer;


// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   Typography,
//   Divider,
//   Avatar,
//   Stack,
//   Button,
//   Collapse,
//   Grid,
//   Paper,
//   IconButton,
//   Tooltip,
//   Popper,
//   ListSubheader,
//   ListItemButton,
//   // Grow removed
//   ClickAwayListener,
// } from "@mui/material"; // Grow removed from imports
// import { RiLogoutCircleRLine } from "react-icons/ri";
// import { RiDashboardLine, RiDashboardFill } from "react-icons/ri";
// import { RiArchiveDrawerLine, RiArchiveDrawerFill } from "react-icons/ri";
// import { RiGroupLine, RiGroupFill } from "react-icons/ri";
// import { RiArchiveStackLine, RiArchiveStackFill } from "react-icons/ri";
// import { RiBubbleChartLine, RiBubbleChartFill } from "react-icons/ri";
// import { RiCornerDownRightLine } from "react-icons/ri";
// import { RiChatVoiceLine,RiChatVoiceFill} from 'react-icons/ri';
// import { RiGitMergeLine, RiGitMergeFill} from "react-icons/ri";
// import { RiQuillPenLine, RiQuillPenFill } from "react-icons/ri";
// // import { RiQuillPenLineAI, RiQuillPenFillAI } from "react-icons/ri";
// import { useAuth } from "../helpers/AuthProvider";
// import { nameRoleObj } from "../helpers/RoleHelper";
// import { ExpandLess, ExpandMore } from "@mui/icons-material";
// import { color } from "framer-motion";

// // Constants and Interfaces (same as before)
// const openDrawerWidth = 250;
// const collapsedDrawerWidth = 72;
// const topSectionApproximateHeight = 180;

// interface NavItem { /* ... same as before ... */
//   id: string;
//   text: string;
//   icon: JSX.Element;
//   clickedIcon: JSX.Element;
//   nav: string;
//   visibility: string[];
//   items: NavItem[];
// }
// const navPaneListOriginal: NavItem[] = [ /* ... same as before ... */
//   {
//     id: "dashboard",
//     text: "Dashboard",
//     icon: <RiDashboardLine />,
//     clickedIcon: <RiDashboardFill />,
//     nav: "/dashboard",
//     visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin"],
//     items: [],
//   },
//   {
//     id: "clusters",
//     text: "Clusters",
//     icon: <RiArchiveDrawerLine />,
//     clickedIcon: <RiArchiveDrawerFill />,
//     nav: "/clusters",
//     visibility: ["cluster_owner", "application_owner", "idp_admin"],
//     items: [],
//   },
//   {
//     id: "applications",
//     text: "Applications",
//     icon: <RiArchiveStackLine />,
//     clickedIcon: <RiArchiveStackFill />,
//     nav: "/applications",
//     visibility: ["cluster_owner", "application_owner", "idp_admin", "developer"],
//     items: [],
//   },
//   {
//     id: "services",
//     text: "Services",
//     icon: <RiBubbleChartLine />,
//     clickedIcon: <RiBubbleChartFill />,
//     nav: "/services",
//     visibility: ["application_owner", "idp_admin", "developer"],
//     items: [],
//   },
//   {
//     id: "aisolutions",
//     text: "AI Solutions",
//     icon: (
//       <img
//         src="/assets/quill-pen-ai-line copy.svg" // <-- REPLACE THIS PATH
//         alt="AI Solutions"
//         style={{color:'#FFFFFF', fontWeight:"bold"}}
//       />
//     ),
//     clickedIcon: <RiQuillPenFill />,
//     nav: "",
//     visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin"],
//     items:[
//       { id: "aisolutions-aiagent", text: "AI Agent", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/aiagent", visibility: ["infrastructure_admin", "idp_admin"], items: [] },
//       { id: "aisolutions-rag", text: "RAG", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/rag", visibility: ["infrastructure_admin", "idp_admin"], items: [] }
//     ],
//   },
//   {
//     id: "integrations",
//     text: "Integrations",
//     icon: <RiGitMergeLine/>,
//     clickedIcon: <RiGitMergeFill />,
//     nav: "/integrations/integrations",
//     visibility: ["idp_admin", "infrastructure_admin", "application_owner", "cluster_owner", "developer"],
//     items: [],
//   },
//   {
//     id: "user-management",
//     text: "User Management",
//     icon: <RiGroupLine />,
//     clickedIcon: <RiGroupFill />,
//     nav: "/user-management",
//     visibility: ["idp_admin"],
//     items: [],
//   },
//   {
//     id: "requests",
//     text: "Requests",
//     icon: <RiCornerDownRightLine />,
//     clickedIcon: <RiCornerDownRightLine />,
//     nav: "",
//     visibility: ["infrastructure_admin", "application_owner", "idp_admin"],
//     items: [
//       { id: "requests-cluster", text: "Clusters", icon: <RiArchiveDrawerLine /> , clickedIcon: <RiArchiveDrawerFill /> , nav: "/requests/clusters", visibility: ["infrastructure_admin", "idp_admin"], items: [] },
//       { id: "requests-application", text: "Applications", icon: <RiArchiveStackLine /> , clickedIcon: <RiArchiveStackFill /> , nav: "/requests/applications", visibility: ["infrastructure_admin", "idp_admin"], items: [] },
//       { id: "requests-service", text: "Services", icon: <RiBubbleChartLine /> , clickedIcon: <RiBubbleChartFill /> , nav: "/requests/services", visibility: ["application_owner", "idp_admin"], items: [] },
//     ],
//   },
// ];
// interface HomepageProps { index: string; }
// const simpleTooltipSx = { /* ... same as before ... */
//   bgcolor: '#FFFFFF',
//   color: '#212121',
//   borderRadius: '6px',
//   boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
//   padding: '6px 10px',
//   fontSize: '13px',
//   fontFamily: 'Gilroy-Regular',
//   border: '1px solid #E0E0E0',
// };
// const simpleTooltipPopperProps = { /* ... same as before ... */
//   disablePortal: false,
//   modifiers: [
//     {
//       name: 'offset',
//       options: {
//         offset: [0, 10],
//       },
//     },
//   ],
// };


// const MainDrawer: React.FC<HomepageProps> = ({ index }) => {
//   const { user, logoutUser } = useAuth();
//   const navigate = useNavigate();

//   const [isDrawerOpen, setIsDrawerOpen] = useState(() => {
//     const storedState = localStorage.getItem('isFaradayDrawerOpen');
//     return storedState !== null ? JSON.parse(storedState) : true;
//   });

//   useEffect(() => {
//     localStorage.setItem('isFaradayDrawerOpen', JSON.stringify(isDrawerOpen));
//   }, [isDrawerOpen]);

  

//   const filteredNavPaneList: NavItem[] = React.useMemo(() => {
//      // Omitted for brevity - same as before
//      if (!user || !user.roles) return [];
//      let list = navPaneListOriginal.filter((element: NavItem) =>
//        element.visibility.some((e: any) => user.roles.includes(e))
//      );
//      list = list.map((element: NavItem) => ({
//        ...element,
//        items: element.items.filter((el: NavItem) =>
//          el.visibility.some((e: any) => user.roles.includes(e))
//        ),
//      }));
//      return list;
//   }, [user]);

//   const [nestedOpen, setNestedOpen] = useState<any>(
//     index.includes("-") ? { [index.split("-")[0]]: true } : {}
//   );
//   const [selectedMenu, setSelectedMenu] = useState(index);

//   const [popperAnchorEl, setPopperAnchorEl] = useState<null | HTMLElement>(null);
//   const [openPopperMenuId, setOpenPopperMenuId] = useState<null | string>(null);
//   const popperTimeoutRef = useRef<NodeJS.Timeout | null>(null);

//   const handleNestedClick = (name: any) => {
//     // Omitted for brevity - same as before
//      if (isDrawerOpen) {
//       setNestedOpen((prev: any) => ({ ...prev, [name]: !prev[name] }));
//     }
//   };

//   const handleMenuSelect = (key: any) => {
//     setSelectedMenu(key);
//   };

//   const toggleDrawer = () => {
//     // Omitted for brevity - same as before
//     setIsDrawerOpen(!isDrawerOpen);
//     if (isDrawerOpen) {
//         setNestedOpen({});
//     }
//     setPopperAnchorEl(null);
//     setOpenPopperMenuId(null);
//   };

//   const currentDrawerWidth = isDrawerOpen ? openDrawerWidth : collapsedDrawerWidth;

//   // --- MODIFIED handleParentMenuMouseEnter ---
//   const handleParentMenuMouseEnter = (event: React.MouseEvent<HTMLElement>, menu: NavItem) => {
//     // Only clear the close timer if the mouse is entering the anchor of the *currently open* Popper.
//     // If entering a different item, let the existing timer (from the previous item's leave event) close the Popper.
//     if (openPopperMenuId === menu.id) {
//         if (popperTimeoutRef.current) {
//             clearTimeout(popperTimeoutRef.current);
//             popperTimeoutRef.current = null;
//         }
//     }
//     // else: Entering a different item OR no popper is open. Don't clear timer here.

//     // Proceed to potentially open the Popper for the item being entered
//     if (!isDrawerOpen && menu.items.length > 0) {
//         // Set the anchor and ID to open the popper for this menu item
//         setPopperAnchorEl(event.currentTarget);
//         setOpenPopperMenuId(menu.id);
//     }
//     // If entering an item that doesn't have children, no popper is opened by this handler.
//     // The handleParentMenuMouseLeave handler of the *previous* item is responsible for closing any previously open popper via its timeout.
//   };


//   const handleParentMenuMouseLeave = () => {
//     // When leaving an item that *might* have triggered a popper, start a timer to close it.
//     // This allows time to move into the popper itself.
//      if (popperTimeoutRef.current) { // Clear any existing timer before setting a new one
//         clearTimeout(popperTimeoutRef.current);
//      }
//     popperTimeoutRef.current = setTimeout(() => {
//       closePopper();
//     }, 150); // Adjust delay if needed
//   };

//   const handlePopperMouseEnter = () => {
//     // When entering the popper itself, clear the close timer.
//     if (popperTimeoutRef.current) {
//       clearTimeout(popperTimeoutRef.current);
//       popperTimeoutRef.current = null;
//     }
//   };

//   const handlePopperMouseLeave = () => {
//     // When leaving the popper, start the close timer again.
//      if (popperTimeoutRef.current) { // Clear any existing timer
//         clearTimeout(popperTimeoutRef.current);
//      }
//     popperTimeoutRef.current = setTimeout(() => {
//       closePopper();
//     }, 150); // Adjust delay if needed
//   };

//   // Function to close the popper - remains the same
//   const closePopper = () => {
//     if (popperTimeoutRef.current) {
//        clearTimeout(popperTimeoutRef.current);
//        popperTimeoutRef.current = null;
//     }
//     // Check if already closed to prevent unnecessary state updates
//     if (popperAnchorEl !== null || openPopperMenuId !== null) {
//         setPopperAnchorEl(null);
//         setOpenPopperMenuId(null);
//     }
//   }

//   const currentOpenPopperMenu = openPopperMenuId ? filteredNavPaneList.find((m: NavItem) => m.id === openPopperMenuId) : null;

//   return (
//     <>
//       <Drawer
//          variant="permanent"
//          sx={{ /* ... drawer styles ... */
//           width: currentDrawerWidth,
//           flexShrink: 0,
//           height: "100vh",
//           [`& .MuiDrawer-paper`]: {
//             width: currentDrawerWidth,
//             boxSizing: "border-box",
//             backgroundColor: "black",
//             color: "white",
//             display: "flex",
//             flexDirection: "column",
//             overflowX: "hidden",
//             transition: (theme) => theme.transitions.create('width', {
//               easing: theme.transitions.easing.sharp,
//               duration: theme.transitions.duration.enteringScreen,
//             }),
//           },
//         }}
//       >
//         {/* Omitted Top Section / User Details / Divider for brevity */}
//          {/* Top Section: Logo and User Details */}
//         <Box sx={{ paddingBottom: isDrawerOpen ? 0 : '8px' }}>
//           {/* Omitted Box content for Logo for brevity */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: isDrawerOpen ? "flex-start" : "center",
//               paddingLeft: isDrawerOpen ? 2 : 0,
//               mt: "12px",
//               minHeight: "54px",
//               gap: isDrawerOpen ? 1 : 0,
//             }}
//           >
//             <img
//               src="/assets/Logo.svg"
//               alt="Faraday Logo"
//               style={{
//                   width: isDrawerOpen ? "54px" : "40px",
//                   height: isDrawerOpen ? "54px" : "40px",
//                   marginLeft: isDrawerOpen ? 0 : '0px',
//                }}
//             />
//             {isDrawerOpen && (
//               <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" noWrap>
//                 Faraday
//               </Typography>
//             )}
//           </Box>

//           {/* Omitted User Details section for brevity */}
//           {user && (
//              <>
//               {isDrawerOpen ? (
//                  <>
//                   <Stack direction="column" marginTop="-20px">
//                     <Avatar
//                       src={user.googleProfilePicture}
//                       alt={user.name || "User Avatar"}
//                       sx={{
//                         width: "56px", height: "56px", marginLeft: "24px",
//                         position: "relative", top: 39, border: "3px solid black",
//                       }}
//                     />
//                     <Box
//                       sx={{
//                         backgroundColor: "#212121", borderRadius: "8px", padding: "10px",
//                         margin: "20px", display: "flex", flexDirection: "column"
//                       }}
//                     >
//                       <Typography fontFamily="Gilroy-Bold" fontSize="16px" marginTop="10px" marginLeft="4px">
//                         {user.name}
//                       </Typography>
//                       <Grid container gap={0.5} mt={0.5}>
//                         {user.roles?.map((e: string) => (
//                           <Grid item key={e}>
//                             <Paper
//                               elevation={3}
//                               sx={{ borderRadius: 10, backgroundColor: "#555", padding: "2px 0px" }}
//                             >
//                               <Box px={1}>
//                                 <Typography fontSize="10px" fontFamily="Gilroy-Regular" color="#fff">
//                                   {nameRoleObj[e] || e}
//                                 </Typography>
//                               </Box>
//                             </Paper>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     </Box>
//                   </Stack>
//                   <Divider color="#181818" sx={{ mt: "8px", mb: "8px", mx: "16px" }} />
//                 </>

//               ) : (
//                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 1, mt: 1 }}>
//                     <Tooltip
//                         title={user.name || "User"}
//                         placement="right"
//                         componentsProps={{
//                            tooltip: { sx: simpleTooltipSx },
//                            popper: { ...simpleTooltipPopperProps }
//                         }}
//                         >
//                         <Avatar
//                             src={user.googleProfilePicture} alt={user.name || "User Avatar"}
//                             sx={{ width: "40px", height: "40px", border: '2px solid #444' }}
//                         />
//                     </Tooltip>
//                  </Box>
//               )}
//             </>
//           )}
//         </Box>
//         <Box sx={{ borderBottom: '1px solid #212121', mt: (isDrawerOpen && user) ? 0 : 1, mb:1 }}/>


//         {/* Scrollable Navigation List */}
//         <Box sx={{ overflowY: "auto", flex: 1 }}>
//           <List sx={{ px: isDrawerOpen ? "8px" : "4px", mx: isDrawerOpen ? "8px" : "4px" , my: isDrawerOpen ? "0px":"5vh"}}>
//             {filteredNavPaneList.map((menu: NavItem) => (
//               <React.Fragment key={menu.id}>
//                 <Tooltip
//                   title={(isDrawerOpen || menu.items.length > 0) ? "" : menu.text}
//                   placement="right"
//                   componentsProps={!isDrawerOpen && menu.items.length === 0 ? {
//                      tooltip: { sx: simpleTooltipSx },
//                      popper: { ...simpleTooltipPopperProps }
//                   } : {}}
//                 >
//                   <ListItem
//                      component="div"
//                      onMouseEnter={(e) => handleParentMenuMouseEnter(e, menu)}
//                      onMouseLeave={handleParentMenuMouseLeave}
//                      onClick={() => { /* ... click handler ... */
//                        if (menu.items.length > 0 && isDrawerOpen) {
//                         handleNestedClick(menu.id);
//                       } else if (menu.items.length === 0) {
//                         handleMenuSelect(menu.id);
//                         if (menu.nav) navigate(menu.nav);
//                         closePopper();
//                       }
//                      }}
//                      sx={{ /* ... item styles ... */
//                        cursor: "pointer", borderRadius: "8px",
//                       backgroundColor: menu.id === selectedMenu ? "#fff" : "transparent",
//                       color: menu.id === selectedMenu ? "#000" : "#fff",
//                       mb: 1, justifyContent: isDrawerOpen ? "flex-start" : "center",
//                       padding: isDrawerOpen ? "8px 16px" : "12px 0",
//                       '&:hover': {
//                           backgroundColor: openPopperMenuId === menu.id ? undefined : (menu.id === selectedMenu ? "#eee" : (isDrawerOpen ? "#212121" : "#333")),
//                       }
//                      }}
//                      aria-describedby={openPopperMenuId === menu.id ? `popper-${menu.id}` : undefined}
//                   >
//                     {/* Omitted ListItemIcon/Text for brevity */}
//                      <ListItemIcon
//                       sx={{
//                           color: "inherit", minWidth: "unset", mr: isDrawerOpen ? 1 : 0, justifyContent: 'center',
//                       }}>
//                       {menu.id === selectedMenu && menu.clickedIcon ? menu.clickedIcon : menu.icon}
//                     </ListItemIcon>
//                     {isDrawerOpen && (
//                       <ListItemText>
//                         <Typography fontFamily="Gilroy-Bold" fontSize="14px">{menu.text}</Typography>
//                       </ListItemText>
//                     )}
//                     {isDrawerOpen && menu.items.length > 0 && (nestedOpen[menu.id] ? <ExpandLess /> : <ExpandMore />)}
//                   </ListItem>
//                 </Tooltip>

//                 {/* Omitted Collapse section for brevity */}
//                  {isDrawerOpen && menu.items.length > 0 && (
//                   <Collapse in={nestedOpen[menu.id]} timeout="auto" unmountOnExit>
//                     <List sx={{ mx: 2, pl: 2 }}>
//                       {menu.items.map((item: NavItem) => (
//                        <Tooltip title="" placement="right" key={item.id} >
//                         <ListItem
//                           onClick={() => {
//                             handleMenuSelect(item.id);
//                             if (item.nav) navigate(item.nav);
//                           }}
//                           sx={{
//                             cursor: "pointer", borderRadius: "8px",
//                             backgroundColor: item.id === selectedMenu ? "#ffffff" : "transparent",
//                             color: item.id === selectedMenu ? "#000" : "#fff",
//                             mb: 0.5, paddingLeft: '16px',
//                              '&:hover': { backgroundColor: item.id === selectedMenu ? "#eee" : "#212121" }
//                           }}
//                         >
//                           {isDrawerOpen && (
//                               <ListItemText>
//                               <Typography fontFamily="Gilroy-Bold" fontSize="14px">{item.text}</Typography>
//                               </ListItemText>
//                           )}
//                         </ListItem>
//                         </Tooltip>
//                       ))}
//                     </List>
//                   </Collapse>
//                 )}
//               </React.Fragment>
//             ))}
//           </List>
//         </Box>

//         {/* Omitted Bottom Section for brevity */}
//          {/* Bottom Section: Sign Out Button */}
//         <Box sx={{ marginTop: 'auto', padding: isDrawerOpen ? '0 8px 8px 8px' : '8px 4px' }}>
//           {isDrawerOpen && <Divider sx={{ bgcolor: "#212121", mx: "8px", mb:1 }} />}
//           <Tooltip
//               title={isDrawerOpen ? "" : "Sign Out"}
//               placement="right"
//               componentsProps={!isDrawerOpen ? {
//                  tooltip: { sx: simpleTooltipSx },
//                  popper: { ...simpleTooltipPopperProps }
//               } : {}}
//           >
//               <Button
//                 fullWidth variant="text"
//                 sx={{
//                     backgroundColor: "black", color: "white", display: "flex",
//                     justifyContent: isDrawerOpen ? "flex-start" : "center",
//                     alignItems: "center",
//                     "&:hover": { backgroundColor: "#212121", color: "white" },
//                     textTransform: "none", padding: isDrawerOpen ? "12px 16px" : "12px 0",
//                 }}
//                 onClick={() => { logoutUser(); navigate("/login"); }}
//               >
//                 <RiLogoutCircleRLine size={isDrawerOpen? 20 : 24} />
//                 {isDrawerOpen && (
//                     <Typography fontFamily="Gilroy-Regular" fontSize="14px" ml="8px" color="#FFFFFF">
//                     Sign Out
//                     </Typography>
//                 )}
//               </Button>
//           </Tooltip>
//         </Box>
//       </Drawer>

//        {/* Omitted Drawer Toggle Button for brevity */}
//         {/* Drawer Toggle Button */}
//       <Box
//         sx={{
//           position: 'fixed',
//           top: topSectionApproximateHeight - 20,
//           left: currentDrawerWidth,
//           transform: 'translateX(-50%) translateY(-50%)',
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//           backgroundColor: '#FFFFFF',
//           borderRadius: '50%',
//           boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
//           transition: 'left 0.2s ease-in-out',
//         }}
//       >
         
//           <IconButton
//             onClick={toggleDrawer}
//             sx={{ padding: '8px' }}
//           >
//              {isDrawerOpen ? (
//               <img
//                 src="/assets/arrow-left-s-line.svg"
//                 alt="Collapse menu"
//                 style={{ width: 14, height: 14, display: 'block' }}
//               />
//             ) : (
//               <img
//                 src="/assets/arrow-right-s-line.svg"
//                 alt="Expand menu"
//                 style={{ width: 14, height: 14, display: 'block' }}
//               />
//             )}
//           </IconButton>
       
//       </Box>

//       {/* Popper - positioning and event handlers updated */}
//       {currentOpenPopperMenu && (
//         <Popper
//           id={popperAnchorEl ? `popper-${openPopperMenuId}` : undefined}
//           // Ensure 'open' reflects the state accurately
//           open={Boolean(popperAnchorEl) && !isDrawerOpen && openPopperMenuId === currentOpenPopperMenu.id}
//           anchorEl={popperAnchorEl}
//           role="tooltip"
//           placement="right"
//           modifiers={[ { name: 'offset', options: { offset: [10, 0] } } ]}
//           sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
//           onMouseEnter={handlePopperMouseEnter} // Keep popper open if entered
//           onMouseLeave={handlePopperMouseLeave} // Start close timer if leaving popper
//         >
//               <Paper sx={{ /* ... paper styles ... */
//                    backgroundColor: '#FFFFFF',
//                   color: '#212121',
//                   borderRadius: '8px',
//                   boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
//                   minWidth: 180,
//                   border: '1px solid #E0E0E0',
//                }}>
//                 <ClickAwayListener onClickAway={closePopper}>
//                    {/* Omitted List content for brevity */}
//                    <List dense component="nav" subheader={
//                     <ListSubheader component="div" sx={{
//                         bgcolor: 'transparent',
//                         color: '#333333',
//                         fontFamily: 'Gilroy-SemiBold',
//                         fontSize: '13px',
//                         lineHeight: '2.5',
//                         textTransform: 'uppercase',
//                         pl: 2
//                     }}>
//                       {currentOpenPopperMenu.text}
//                     </ListSubheader>
//                   }>
//                     {currentOpenPopperMenu.items.map((subItem: NavItem) => (
//                       <ListItemButton
//                         key={subItem.id}
//                         selected={subItem.id === selectedMenu}
//                         onClick={() => {
//                           handleMenuSelect(subItem.id);
//                           if (subItem.nav) navigate(subItem.nav);
//                           closePopper();
//                         }}
//                         sx={{
//                           pl: 2, pr:2, py: 0.75,
//                           '&.Mui-selected': {
//                             backgroundColor: '#f0f0f0',
//                             color: '#000000',
//                             '&:hover': { backgroundColor: '#e0e0e0' }
//                           },
//                           '&:hover': {
//                             backgroundColor: '#f5f5f5'
//                           }
//                         }}
//                       >
//                         <ListItemText
//                           primary={subItem.text}
//                           primaryTypographyProps={{
//                             fontSize: '14px',
//                             fontFamily: 'Gilroy-Regular',
//                             color: subItem.id === selectedMenu ? '#000000' : '#333333'
//                           }}
//                         />
//                       </ListItemButton>
//                     ))}
//                   </List>
//                 </ClickAwayListener>
//               </Paper>
//         </Popper>
//       )}
//     </>
//   );
// };
// export default MainDrawer;


// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   Typography,
//   Divider,
//   Avatar,
//   Stack,
//   Button,
//   Collapse,
//   Grid,
//   Paper,
//   IconButton,
//   Tooltip,
//   Popper, 
//   ListSubheader, 
//   ListItemButton, 
//   Grow, 
//   ClickAwayListener, 
// } from "@mui/material";
// import { RiLogoutCircleRLine } from "react-icons/ri";
// import { RiDashboardLine, RiDashboardFill } from "react-icons/ri";
// import { RiArchiveDrawerLine, RiArchiveDrawerFill } from "react-icons/ri";
// import { RiGroupLine, RiGroupFill } from "react-icons/ri";
// import { RiArchiveStackLine, RiArchiveStackFill } from "react-icons/ri";
// import { RiBubbleChartLine, RiBubbleChartFill } from "react-icons/ri";
// import { RiCornerDownRightLine } from "react-icons/ri";
// import { RiChatVoiceLine,RiChatVoiceFill} from 'react-icons/ri';
// import { RiGitMergeLine, RiGitMergeFill} from "react-icons/ri";

// import { useAuth } from "../helpers/AuthProvider"; 
// import { nameRoleObj } from "../helpers/RoleHelper"; 
// import { ExpandLess, ExpandMore } from "@mui/icons-material";

// // Original drawer width when open
// const openDrawerWidth = 250;
// // Drawer width when collapsed (enough for icons)
// const collapsedDrawerWidth = 72;
// // Approximate height of the logo and user info section, for positioning the toggle button
// const topSectionApproximateHeight = 180; 

// // Define an interface for the navigation item structure
// interface NavItem {
//   id: string;
//   text: string;
//   icon: JSX.Element;
//   clickedIcon: JSX.Element;
//   nav: string;
//   visibility: string[];
//   items: NavItem[]; // items is now a required array
// }

// // Initial navigation pane list
// // All items now have an 'items: []' property if they don't have sub-items.
// const navPaneListOriginal: NavItem[] = [ 
//   {
//     id: "dashboard",
//     text: "Dashboard",
//     icon: <RiDashboardLine />,
//     clickedIcon: <RiDashboardFill />,
//     nav: "/dashboard",
//     visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin"],
//     items: [], 
//   },
//   {
//     id: "clusters",
//     text: "Clusters",
//     icon: <RiArchiveDrawerLine />,
//     clickedIcon: <RiArchiveDrawerFill />,
//     nav: "/clusters",
//     visibility: ["cluster_owner", "application_owner", "idp_admin"],
//     items: [],
//   },
//   {
//     id: "applications",
//     text: "Applications",
//     icon: <RiArchiveStackLine />,
//     clickedIcon: <RiArchiveStackFill />,
//     nav: "/applications",
//     visibility: ["cluster_owner", "application_owner", "idp_admin", "developer"],
//     items: [],
//   },
//   {
//     id: "services",
//     text: "Services",
//     icon: <RiBubbleChartLine />,
//     clickedIcon: <RiBubbleChartFill />,
//     nav: "/services",
//     visibility: ["application_owner", "idp_admin", "developer"],
//     items: [],
//   },
//   {
//     id: "aisolutions",
//     text: "AI Solutions",
//     icon: <RiChatVoiceLine/>,
//     clickedIcon: <RiChatVoiceFill />,
//     nav: "", 
//     visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin"],
//     items:[
//       { id: "aisolutions-aiagent", text: "AI Agent", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/aiagent", visibility: ["infrastructure_admin", "idp_admin"], items: [] },
//       { id: "aisolutions-rag", text: "RAG", icon: <RiChatVoiceLine/> , clickedIcon: <RiChatVoiceFill/> , nav: "/aisolutions/rag", visibility: ["infrastructure_admin", "idp_admin"], items: [] }
//     ],
//   },
//   {
//     id: "integrations",
//     text: "Integrations",
//     icon: <RiGitMergeLine/>,
//     clickedIcon: <RiGitMergeFill />,
//     nav: "/integrations/integrations",
//     visibility: ["idp_admin", "infrastructure_admin", "application_owner", "cluster_owner", "developer"],
//     items: [],
//   },
//   {
//     id: "user-management",
//     text: "User Management",
//     icon: <RiGroupLine />,
//     clickedIcon: <RiGroupFill />,
//     nav: "/user-management",
//     visibility: ["idp_admin"],
//     items: [],
//   },
//   {
//     id: "requests",
//     text: "Requests",
//     icon: <RiCornerDownRightLine />,
//     clickedIcon: <RiCornerDownRightLine />,
//     nav: "", 
//     visibility: ["infrastructure_admin", "application_owner", "idp_admin"],
//     items: [
//       { id: "requests-cluster", text: "Clusters", icon: <RiArchiveDrawerLine /> , clickedIcon: <RiArchiveDrawerFill /> , nav: "/requests/clusters", visibility: ["infrastructure_admin", "idp_admin"], items: [] },
//       { id: "requests-application", text: "Applications", icon: <RiArchiveStackLine /> , clickedIcon: <RiArchiveStackFill /> , nav: "/requests/applications", visibility: ["infrastructure_admin", "idp_admin"], items: [] },
//       { id: "requests-service", text: "Services", icon: <RiBubbleChartLine /> , clickedIcon: <RiBubbleChartFill /> , nav: "/requests/services", visibility: ["application_owner", "idp_admin"], items: [] },
//     ],
//   },
// ];

// interface HomepageProps {
//   index: string; 
// }

// const MainDrawer: React.FC<HomepageProps> = ({ index }) => {
//   const { user, logoutUser } = useAuth();
//   const navigate = useNavigate();

//   const [isDrawerOpen, setIsDrawerOpen] = useState(() => {
//     const storedState = localStorage.getItem('isFaradayDrawerOpen');
//     return storedState !== null ? JSON.parse(storedState) : true;
//   });

//   useEffect(() => {
//     localStorage.setItem('isFaradayDrawerOpen', JSON.stringify(isDrawerOpen));
//   }, [isDrawerOpen]);

//   const filteredNavPaneList: NavItem[] = React.useMemo(() => { 
//     if (!user || !user.roles) return []; // Return empty list if user or roles are not available
//     let list = navPaneListOriginal.filter((element: NavItem) =>  
//       element.visibility.some((e: any) => user.roles.includes(e))
//     );
//     // element.items is now guaranteed to be an array by NavItem interface and navPaneListOriginal structure
//     list = list.map((element: NavItem) => ({ 
//       ...element,
//       // Filter sub-items based on visibility. element.items is always an array.
//       items: element.items.filter((el: NavItem) => 
//         el.visibility.some((e: any) => user.roles.includes(e))
//       ),
//     }));
//     return list;
//   }, [user]);

//   const [nestedOpen, setNestedOpen] = useState<any>(
//     index.includes("-") ? { [index.split("-")[0]]: true } : {}
//   );
//   const [selectedMenu, setSelectedMenu] = useState(index);

//   const [popperAnchorEl, setPopperAnchorEl] = useState<null | HTMLElement>(null);
//   const [openPopperMenuId, setOpenPopperMenuId] = useState<null | string>(null);
//   const popperTimeoutRef = useRef<NodeJS.Timeout | null>(null);

//   const handleNestedClick = (name: any) => {
//     if (isDrawerOpen) {
//       setNestedOpen((prev: any) => ({ ...prev, [name]: !prev[name] }));
//     }
//   };

//   const handleMenuSelect = (key: any) => {
//     setSelectedMenu(key);
//   };

//   const toggleDrawer = () => {
//     setIsDrawerOpen(!isDrawerOpen);
//     if (isDrawerOpen) { 
//         setNestedOpen({});
//     }
//     setPopperAnchorEl(null); 
//     setOpenPopperMenuId(null);
//   };
  
//   const currentDrawerWidth = isDrawerOpen ? openDrawerWidth : collapsedDrawerWidth;

//   const handleParentMenuMouseEnter = (event: React.MouseEvent<HTMLElement>, menu: NavItem) => { 
//     if (popperTimeoutRef.current) {
//       clearTimeout(popperTimeoutRef.current);
//     }
//     // menu.items is now always an array, so check its length
//     if (!isDrawerOpen && menu.items.length > 0) {
//       setPopperAnchorEl(event.currentTarget);
//       setOpenPopperMenuId(menu.id);
//     }
//   };

//   const handleParentMenuMouseLeave = () => {
//     popperTimeoutRef.current = setTimeout(() => {
//       setPopperAnchorEl(null);
//       setOpenPopperMenuId(null);
//     }, 150); 
//   };
  
//   const handlePopperMouseEnter = () => {
//     if (popperTimeoutRef.current) {
//       clearTimeout(popperTimeoutRef.current);
//     }
//   };

//   const handlePopperMouseLeave = () => {
//      popperTimeoutRef.current = setTimeout(() => {
//       setPopperAnchorEl(null);
//       setOpenPopperMenuId(null);
//     }, 150);
//   };

//   const closePopper = () => {
//     setPopperAnchorEl(null);
//     setOpenPopperMenuId(null);
//   }

//   const currentOpenPopperMenu = openPopperMenuId ? filteredNavPaneList.find((m: NavItem) => m.id === openPopperMenuId) : null;

//   return (
//     <>
//       <Drawer
//         variant="permanent"
//         sx={{
//           width: currentDrawerWidth,
//           flexShrink: 0,
//           height: "100vh",
//           [`& .MuiDrawer-paper`]: {
//             width: currentDrawerWidth,
//             boxSizing: "border-box",
//             backgroundColor: "black",
//             color: "white",
//             display: "flex",
//             flexDirection: "column",
//             overflowX: "hidden", 
//             transition: (theme) => theme.transitions.create('width', {
//               easing: theme.transitions.easing.sharp,
//               duration: theme.transitions.duration.enteringScreen,
//             }),
//           },
//         }}
//       >
//         {/* Top Section: Logo and User Details */}
//         <Box sx={{ paddingBottom: isDrawerOpen ? 0 : '8px' }}>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: isDrawerOpen ? "flex-start" : "center",
//               paddingLeft: isDrawerOpen ? 2 : 0,
//               mt: "12px",
//               minHeight: "54px", 
//               gap: isDrawerOpen ? 1 : 0,
//             }}
//           >
//             <img
//               src="/assets/Logo.svg" 
//               alt="Faraday Logo"
//               style={{ 
//                   width: isDrawerOpen ? "54px" : "40px",
//                   height: isDrawerOpen ? "54px" : "40px",
//                   marginLeft: isDrawerOpen ? 0 : '0px',
//                }}
//             />
//             {isDrawerOpen && (
//               <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" noWrap>
//                 Faraday
//               </Typography>
//             )}
//           </Box>

//           {user && (
//             <>
//               {isDrawerOpen ? (
//                 <>
//                   <Stack direction="column" marginTop="-20px">
//                     <Avatar
//                       src={user.googleProfilePicture} 
//                       alt={user.name || "User Avatar"}
//                       sx={{
//                         width: "56px", height: "56px", marginLeft: "24px",
//                         position: "relative", top: 39, border: "3px solid black",
//                       }}
//                     />
//                     <Box
//                       sx={{
//                         backgroundColor: "#212121", borderRadius: "8px", padding: "10px",
//                         margin: "20px", display: "flex", flexDirection: "column"
//                       }}
//                     >
//                       <Typography fontFamily="Gilroy-Bold" fontSize="16px" marginTop="10px" marginLeft="4px">
//                         {user.name}
//                       </Typography>
//                       <Grid container gap={0.5} mt={0.5}>
//                         {user.roles?.map((e: string) => (
//                           <Grid item key={e}>
//                             <Paper
//                               elevation={3}
//                               sx={{ borderRadius: 10, backgroundColor: "#555", padding: "2px 0px" }}
//                             >
//                               <Box px={1}>
//                                 <Typography fontSize="10px" fontFamily="Gilroy-Regular" color="#fff">
//                                   {nameRoleObj[e] || e}
//                                 </Typography>
//                               </Box>
//                             </Paper>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     </Box>
//                   </Stack>
//                   <Divider color="#181818" sx={{ mt: "8px", mb: "8px", mx: "16px" }} />
//                 </>
//               ) : (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', py: 1, mt: 1 }}>
//                   <Tooltip title={user.name || "User"} placement="right" arrow>
//                       <Avatar
//                           src={user.googleProfilePicture} alt={user.name || "User Avatar"}
//                           sx={{ width: "40px", height: "40px", border: '2px solid #444' }}
//                       />
//                   </Tooltip>
//                 </Box>
//               )}
//             </>
//           )}
//         </Box>
        
//         <Box sx={{ borderBottom: '1px solid #212121', mt: (isDrawerOpen && user) ? 0 : 1, mb:1 }}/>


//         {/* Scrollable Navigation List */}
//         <Box sx={{ overflowY: "auto", flex: 1 }}>
//           <List sx={{ px: isDrawerOpen ? "8px" : "4px", mx: isDrawerOpen ? "8px" : "4px" , my: isDrawerOpen ? "0px":"5vh"}}>
//             {filteredNavPaneList.map((menu: NavItem) => ( 
//               <React.Fragment key={menu.id}>
//                 {/* menu.items is now always an array, check its length for tooltip logic */}
//                 <Tooltip title={(isDrawerOpen || menu.items.length > 0) ? "" : menu.text} placement="right" sx={{ml:'5vw'}} arrow>
//                   <ListItem
//                     component="div"
//                     onMouseEnter={(e) => handleParentMenuMouseEnter(e, menu)}
//                     onMouseLeave={handleParentMenuMouseLeave}
//                     onClick={() => {
//                       // menu.items is now always an array, check its length
//                       if (menu.items.length > 0 && isDrawerOpen) { 
//                         handleNestedClick(menu.id);
//                       } else {
//                         handleMenuSelect(menu.id);
//                         if (menu.nav) {
//                           navigate(menu.nav);
//                         } else if (menu.items.length > 0 && !isDrawerOpen) {
//                           // Clicking parent icon when collapsed now handled by popper
//                         }
//                       }
//                       if (menu.items.length === 0 || !isDrawerOpen) closePopper(); 
//                     }}
//                     sx={{
//                       cursor: "pointer", borderRadius: "8px",
//                       backgroundColor: menu.id === selectedMenu ? (isDrawerOpen ? "#fff" : "#fff") : "transparent",
//                       color: menu.id === selectedMenu ? (isDrawerOpen ? "#000" : "#000") : "#fff",
//                       mb: 1, justifyContent: isDrawerOpen ? "flex-start" : "center",
//                       padding: isDrawerOpen ? "8px 16px" : "12px 0",
//                       '&:hover': {
//                           backgroundColor: menu.id === selectedMenu ? (isDrawerOpen ? "#eee" : "#eee") : (isDrawerOpen ? "#212121" : "#333"),
//                       }
//                     }}
//                   >
//                     <ListItemIcon 
//                       sx={{ 
//                           color: "inherit", minWidth: "unset", mr: isDrawerOpen ? 1 : 0, justifyContent: 'center',
//                       }}>
//                       {menu.id === selectedMenu && menu.clickedIcon ? menu.clickedIcon : menu.icon}
//                     </ListItemIcon>
//                     {isDrawerOpen && (
//                       <ListItemText>
//                         <Typography fontFamily="Gilroy-Bold" fontSize="14px">{menu.text}</Typography>
//                       </ListItemText>
//                     )}
//                     {/* menu.items is now always an array, check its length */}
//                     {isDrawerOpen && menu.items.length > 0 && (nestedOpen[menu.id] ? <ExpandLess /> : <ExpandMore />)}
//                   </ListItem>
//                 </Tooltip>
//                 {/* menu.items is now always an array, check its length */}
//                 {isDrawerOpen && menu.items.length > 0 && (
//                   <Collapse in={nestedOpen[menu.id]} timeout="auto" unmountOnExit>
//                     <List sx={{ mx: 2, pl: 2 }}>
//                       {menu.items.map((item: NavItem) => ( 
//                        <Tooltip title={isDrawerOpen ? "" : item.text} placement="right" arrow key={item.id}>
//                         <ListItem
//                           onClick={() => {
//                             handleMenuSelect(item.id);
//                             if (item.nav) navigate(item.nav);
//                           }}
//                           sx={{
//                             cursor: "pointer", borderRadius: "8px",
//                             backgroundColor: item.id === selectedMenu ? "#ffffff" : "transparent",
//                             color: item.id === selectedMenu ? "#000" : "#fff",
//                             mb: 0.5, paddingLeft: '16px',
//                              '&:hover': { backgroundColor: item.id === selectedMenu ? "#eee" : "#212121" }
//                           }}
//                         >
//                           {isDrawerOpen && (
//                               <ListItemText>
//                               <Typography fontFamily="Gilroy-Bold" fontSize="14px">{item.text}</Typography>
//                               </ListItemText>
//                           )}
//                         </ListItem>
//                         </Tooltip>
//                       ))}
//                     </List>
//                   </Collapse>
//                 )}
//               </React.Fragment>
//             ))}
//           </List>
//         </Box>

//         {/* Bottom Section: Sign Out Button */}
//         <Box sx={{ marginTop: 'auto', padding: isDrawerOpen ? '0 8px 8px 8px' : '8px 4px' }}>
//           {isDrawerOpen && <Divider sx={{ bgcolor: "#212121", mx: "8px", mb:1 }} />}
//           <Tooltip title={isDrawerOpen ? "" : "Sign Out"} placement="right" arrow>
//               <Button
//                 fullWidth variant="text"
//                 sx={{
//                     backgroundColor: "black", color: "white", display: "flex",
//                     justifyContent: isDrawerOpen ? "flex-start" : "center",
//                     alignItems: "center",
//                     "&:hover": { backgroundColor: "#212121", color: "white" },
//                     textTransform: "none", padding: isDrawerOpen ? "12px 16px" : "12px 0",
//                 }}
//                 onClick={() => { logoutUser(); navigate("/login"); }}
//               >
//                 <RiLogoutCircleRLine size={isDrawerOpen? 20 : 24} />
//                 {isDrawerOpen && (
//                     <Typography fontFamily="Gilroy-Regular" fontSize="14px" ml="8px" color="#FFFFFF">
//                     Sign Out
//                     </Typography>
//                 )}
//               </Button>
//           </Tooltip>
//         </Box>
//       </Drawer>

//       {/* Drawer Toggle Button */}
//       <Box
//         sx={{
//           position: 'fixed', 
//           top: topSectionApproximateHeight - 20, 
//           left: currentDrawerWidth, 
//           transform: 'translateX(-50%) translateY(-50%)', 
//           zIndex: (theme) => theme.zIndex.drawer + 1, 
//           backgroundColor: '#FFFFFF', 
//           borderRadius: '50%', 
//           boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
//           transition: 'left 0.2s ease-in-out', 
          
//         }}
//       >
//         <Tooltip title={isDrawerOpen ? "Collapse menu" : "Expand menu"} placement="right" arrow>
//           <IconButton 
//             onClick={toggleDrawer} 
//             sx={{ 
//               padding: '8px', 
//             }}
//           >
//             {isDrawerOpen ? (
//               <img 
//                 src="/assets/arrow-left-s-line.svg" // USER TODO: Replace with your actual path
//                 alt="Collapse menu" 
//                 style={{ width: 14, height: 14, display: 'block' }} 
//               />
//             ) : (
//               <img 
//                 src="/assets/arrow-right-s-line.svg" // USER TODO: Replace with your actual path
//                 alt="Expand menu" 
//                 style={{ width: 14, height: 14, display: 'block' }} 
//               />
//             )}
//           </IconButton>
//         </Tooltip>
//       </Box>

//       {/* Popper for interactive sub-menus when drawer is collapsed */}
//       {/* currentOpenPopperMenu.items is now always an array, check its length */}
//       {currentOpenPopperMenu && currentOpenPopperMenu.items.length > 0 && (
//         <Popper
//           open={Boolean(popperAnchorEl) && !isDrawerOpen}
//           anchorEl={popperAnchorEl}
//           role={undefined}
//           placement="right-start"
//           transition
//           disablePortal 
//           modifiers={[ { name: 'offset', options: { offset: [0, -38], }, }, ]} 
//           sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }} 
//           onMouseEnter={handlePopperMouseEnter}
//           onMouseLeave={handlePopperMouseLeave}
//         >
//           {({ TransitionProps }) => (
//             <Grow {...TransitionProps} timeout={200}>
//               <Paper sx={{ backgroundColor: '#2c2c2c', color: 'white', borderRadius: '8px', boxShadow: 3, minWidth: 180 }}>
//                 <ClickAwayListener onClickAway={closePopper}>
//                   <List dense component="nav" subheader={
//                     <ListSubheader component="div" sx={{ bgcolor: 'transparent', color: '#b0b0b0', fontFamily: 'Gilroy-SemiBold', fontSize: '13px', lineHeight: '2.5' }}>
//                       {currentOpenPopperMenu.text}
//                     </ListSubheader>
//                   }>
//                     {/* currentOpenPopperMenu.items is guaranteed to be an array here by the outer check */}
//                     {currentOpenPopperMenu.items.map((subItem: NavItem) => ( 
//                       <ListItemButton
//                         key={subItem.id}
//                         selected={subItem.id === selectedMenu}
//                         onClick={() => {
//                           handleMenuSelect(subItem.id);
//                           if (subItem.nav) navigate(subItem.nav);
//                           closePopper();
//                         }}
//                         sx={{
//                           pl: 2, pr:2, py: 0.75,
//                           '&.Mui-selected': { backgroundColor: '#444', '&:hover': { backgroundColor: '#555' } },
//                           '&:hover': { backgroundColor: '#3a3a3a' }
//                         }}
//                       >
//                         <ListItemText 
//                           primary={subItem.text} 
//                           primaryTypographyProps={{ fontSize: '14px', fontFamily: 'Gilroy-Regular', color: subItem.id === selectedMenu ? 'white' : '#e0e0e0' }} 
//                         />
//                       </ListItemButton>
//                     ))}
//                   </List>
//                 </ClickAwayListener>
//               </Paper>
//             </Grow>
//           )}
//         </Popper>
//       )}
//     </>
//   );
// };
// export default MainDrawer;



// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Toolbar,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   Typography,
//   Divider,
//   Avatar,
//   Stack,
//   Button,
//   Collapse,
//   Grid,
//   Paper,
// } from "@mui/material";
// import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
// import { RiLogoutCircleRLine } from "react-icons/ri";
// import { RiDashboardLine } from "react-icons/ri";
// import { RiArchiveDrawerLine } from "react-icons/ri";
// import { RiGroupLine } from "react-icons/ri";
// import { RiArchiveStackLine } from "react-icons/ri";
// import { RiBubbleChartLine } from "react-icons/ri";
// import { RiCornerDownRightLine } from "react-icons/ri";
// import { RiChatVoiceLine,RiChatVoiceFill} from 'react-icons/ri';
// import { RiGroupFill } from "react-icons/ri";
// import { RiArchiveDrawerFill } from "react-icons/ri";
// import { RiDashboardFill } from "react-icons/ri";
// import { RiArchiveStackFill } from "react-icons/ri";
// import { RiBubbleChartFill } from "react-icons/ri";
// import {RiGitMergeLine, RiGitMergeFill} from "react-icons/ri"
// import { useAuth } from "../helpers/AuthProvider";

// import { nameRoleObj } from "../helpers/RoleHelper";
// import { ExpandLess, ExpandMore, Visibility } from "@mui/icons-material";
// import queryGraphql from "../helpers/ApiInterface";

// const drawerWidth = 250;

// let navPaneList: any = [
//   {
//     id: "dashboard",
//     text: "Dashboard",
//     icon: <RiDashboardLine />,
//     clickedIcon: <RiDashboardFill />,
//     nav: "/dashboard",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//   },

//   {
//     id: "clusters",
//     text: "Clusters",
//     icon: <RiArchiveDrawerLine />,
//     clickedIcon: <RiArchiveDrawerFill />,
//     nav: "/clusters",
//     visibility: ["cluster_owner", "application_owner", "idp_admin"],
//   },
//   {
//     id: "applications",
//     text: "Applications",
//     icon: <RiArchiveStackLine />,
//     clickedIcon: <RiArchiveStackFill />,
//     nav: "/applications",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//     ],
//   },
//   {
//     id: "services",
//     text: "Services",
//     icon: <RiBubbleChartLine />,
//     clickedIcon: <RiBubbleChartFill />,
//     nav: "/services",
//     visibility: ["application_owner", "idp_admin", "developer"],
//   },
//   {
//     id: "aisolutions",
//     text: "AI Solutions",
//     icon: <RiChatVoiceLine/>,
//     clickedIcon: <RiChatVoiceFill />,
//     nav: "",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//     items:[
//       {
//         id: "aisolutions-aiagent",
//         text: "AI Agent",
//         nav: "/aisolutions/aiagent",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "aisolutions-rag",
//         text: "RAG",
//         nav: "/aisolutions/rag",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       }
//     ],
//   },
//   {
//     id: "integrations",
//     text: "Integrations",
//     icon: <RiGitMergeLine/>,
//     clickedIcon: <RiGitMergeFill />,
//     nav: "/integrations/integrations",
//     visibility: [
//       "idp_admin",
//       "infrastructure_admin",
//       "application_owner",
//       "cluster_owner",
//       "developer"
//     ],
//   },
  
//   {
//     id: "user-management",
//     text: "User Management",
//     icon: <RiGroupLine />,
//     clickedIcon: <RiGroupFill />,
//     nav: "/user-management",
//     visibility: ["idp_admin"],
//   },
//   {
//     id: "requests",
//     text: "Requests",
//     icon: <RiCornerDownRightLine />,
//     clickedIcon: <RiCornerDownRightLine />,
//     nav: "",
//     visibility: ["infrastructure_admin", "application_owner", "idp_admin"],
//     items: [
//       {
//         id: "requests-cluster",
//         text: "Clusters",
//         icon: <RiArchiveDrawerLine />,
//         clickedIcon: <RiArchiveDrawerFill />,
//         nav: "/requests/clusters",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-application",
//         text: "Applications",
//         icon: <RiArchiveStackLine />,
//         clickedIcon: <RiArchiveStackFill />,
//         nav: "/requests/applications",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-service",
//         text: "Services",
//         icon: <RiBubbleChartLine />,
//         clickedIcon: <RiBubbleChartFill />,
//         nav: "/requests/services",
//         visibility: ["application_owner", "idp_admin"],
//       },
//     ],
//   },
  
// ];

// interface HomepageProps {
//   index: string;
// }

// const MainDrawer: React.FC<HomepageProps> = ({ index }) => {
//   const { user, logoutUser } = useAuth();
//   navPaneList = navPaneList.filter((element: any) => {
//     return element.visibility.some((e: any) => user.roles.includes(e));
//   });
//   navPaneList = navPaneList.map((element: any) => {
//     return {
//       ...element,
//       items: element.items?.filter((el: any) => {
//         return el.visibility.some((e: any) => user.roles.includes(e));
//       }),
//     };
//   });

//   const navigate = useNavigate();
//   // const [selectedIndex, setSelectedIndex] = useState(index);
//   const [nestedOpen, setNestedOpen] = useState<any>(
//     index.includes("-") ? { index: true, [index.split("-")[0]]: true } : {}
//   );
//   const [selectedMenu, setSelectedMenu] = useState(index);

//   const handleNestedClick = (name: any) => {
//     setNestedOpen((prev: any) => ({ ...prev, [name]: !prev[name] }));
//   };

//   const handleMenuSelect = (key: any) => {
//     //setSelectedMenu(key);
//       setSelectedMenu(key);
//   };

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: drawerWidth,
//         flexShrink: 0,
//         height: "100%",
//         [`& .MuiDrawer-paper`]: {
//           width: drawerWidth,
//           boxSizing: "border-box",
//           backgroundColor: "black",
//           color: "white",
//           display: "flex",
//           flexDirection: "column",
//         },
//       }}
//     >
//       {/* Static Section - Faraday and User Details */}
//       <Box>
//         {/* <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "start",
//             paddingLeft: 2,
//             minHeight: "32px",
//           }}
//         > */}
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "start", paddingLeft: 2, mt: "12px"}}>
//             <img
//               src="/assets/Logo.svg"
//               alt="Logo Icon"
//               style={{ width: "54px", height: "54px" }}
//             />
//             <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" noWrap>
//               Faraday
//             </Typography>
//           </Box>
//         {/* </Box> */}
//         {user && (
//           <>
//             <Stack direction="column" marginTop="-20px">
//               <Avatar
//                 src={user.googleProfilePicture}
//                 alt="User icon"
//                 sx={{
//                   width: "56px",
//                   height: "56px",
//                   marginLeft: "24px",
//                   position: "relative",
//                   top: 39,
//                   border: "3px solid black",
//                 }}
//               />
//               {/* Added a box with a light gray background */}
//               <Box
//                 sx={{
//                   backgroundColor: "#212121",  // Light gray background
//                   borderRadius: "8px",
//                   padding: "10px",
//                   margin: "20px",
//                   display: "flex",
//                   flexDirection: "column"
//                 }}
//               >
//                 <Typography fontFamily="Gilroy-Bold" fontSize="16px" marginTop="10px" marginLeft="4px">
//                   {user.name}
//                 </Typography>
//                 <Grid container gap={0.5} mt={0.5}>
//                   {user.roles?.map((e: string) => (
//                     <Grid item>
//                       <Paper
//                         elevation={3}
//                         sx={{
//                           borderRadius: 10,
//                           backgroundColor: "#555",
//                           // padding: "4px",
//                         }}
//                       >
//                         <Box px={1}>
//                         <Typography fontSize="10px" fontFamily="Gilroy-Regular" color="#fff">
//                           {nameRoleObj[e]}
//                         </Typography>

//                         </Box>
                        
//                       </Paper>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Box>
//             </Stack>
//             <Divider
//                 color="#181818"
//                 sx={{ marginTop: "8px", marginBottom: "8px", mx: "16px" }}
//               />          </>
//         )}
//       </Box>
//       {/* Scrollable Navigation List */}
//       <Box sx={{ overflowY: "auto", flex: 1 }}>
//         <List sx={{ px: "8px", mx: "8px" }}>
//           {navPaneList.map((menu: any) => (
//             <React.Fragment key={menu.id}>
//               <ListItem
//                 component="div"
//                 onClick={() => {
//                   if (menu.items?.length) {
//                     handleNestedClick(menu.id);
//                   } else {
//                     handleMenuSelect(menu.id);
//                   }
//                   if (menu.nav) navigate(menu.nav);
//                 }}
//                 sx={{
//                   cursor: "pointer",
//                   borderRadius: "8px",
//                   backgroundColor: menu.id === selectedMenu ? "#fff" : "#000",
//                   color: menu.id === selectedMenu ? "#000" : "#fff",
//                 }}
//               >
//                 <ListItemIcon sx={{ color: menu.id === selectedMenu ? "#000" : "#fff", minWidth: "unset", mr: 1 }}>
//                   {menu.id === selectedMenu ? menu.clickedIcon : menu.icon}
//                 </ListItemIcon>
//                 <ListItemText>
//                   <Typography fontFamily="Gilroy-Bold" fontSize="14px">{menu.text}</Typography>
//                 </ListItemText>
//                 {menu.items?.length > 0 && (nestedOpen[menu.id] ? <ExpandLess /> : <ExpandMore />)}
//               </ListItem>
//               {/* Nested Menu Items */}
//               {menu.items?.length > 0 && (
//                 <Collapse in={nestedOpen[menu.id]} timeout="auto" unmountOnExit>
//                   <List sx={{ mx: 2 }}>
//                     {menu.items.map((item: any) => (
//                       <ListItem
//                         key={item.id}
//                         onClick={() => {
//                           handleMenuSelect(item.id);
//                           if (item.nav) navigate(item.nav);
//                         }}
//                         sx={{
//                           cursor: "pointer",
//                           borderRadius: "8px",
//                           backgroundColor: item.id === selectedMenu ? "#fff" : "#000",
//                           color: item.id === selectedMenu ? "#000" : "#fff",
//                         }}
//                       >
//                         <ListItemText>
//                           <Typography fontFamily="Gilroy-Bold" fontSize="14px">{item.text}</Typography>
//                         </ListItemText>
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Collapse>
//               )}
//             </React.Fragment>
//           ))}
//         </List>
//       </Box>
//       {/* Static Section - Sign Out Button */}
//       <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "start", paddingLeft: 2, mt: "12px", width: "80%"}}>
//         <Divider sx={{ bgcolor: "#212121" }} />
//         <Button
//           fullWidth
//           variant="text"
//           sx={{
//             backgroundColor: "black",
//             color: "white",
//             fontWeight: "bold",
//             display: "flex",
//             justifyContent: "flex-start",
//             alignItems: "center",
//             "&:hover": { backgroundColor: "#212121", color: "white" ,},
//             textTransform: "none",
//             pb: "16px",
//             pt: "12px",
//             mt: "8px",
//             // borderRadius: "8px",
//           }}
//           onClick={() => {
//             logoutUser();
//             navigate("/login");
//           }}
//         >
//           <RiLogoutCircleRLine />
//           <Typography fontFamily="Gilroy-Regular" fontSize="14px" ml="8px" color="#FFFFFF">
//             Sign Out
//           </Typography>
//         </Button>
//       </Box>
//     </Drawer>
//   );
// };
// export default MainDrawer;
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Toolbar,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   Typography,
//   Divider,
//   Avatar,
//   Stack,
//   Button,
//   Collapse,
//   Grid,
//   Paper,
//   // ADDED: Import IconButton and useTheme
//   IconButton,
//   useTheme,
// } from "@mui/material";
// import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
// // ADDED: Import Chevron icons for the toggle button
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import { RiLogoutCircleRLine } from "react-icons/ri";
// import { RiDashboardLine } from "react-icons/ri";
// import { RiArchiveDrawerLine } from "react-icons/ri";
// import { RiGroupLine } from "react-icons/ri";
// import { RiArchiveStackLine } from "react-icons/ri";
// import { RiBubbleChartLine } from "react-icons/ri";
// import { RiCornerDownRightLine } from "react-icons/ri";
// import { RiChatVoiceLine,RiChatVoiceFill} from 'react-icons/ri';
// import { RiGroupFill } from "react-icons/ri";
// import { RiArchiveDrawerFill } from "react-icons/ri";
// import { RiDashboardFill } from "react-icons/ri";
// import { RiArchiveStackFill } from "react-icons/ri";
// import { RiBubbleChartFill } from "react-icons/ri";
// import {RiGitMergeLine, RiGitMergeFill} from "react-icons/ri"
// import { useAuth } from "../helpers/AuthProvider";

// import { nameRoleObj } from "../helpers/RoleHelper";
// import { ExpandLess, ExpandMore, Visibility } from "@mui/icons-material";
// import queryGraphql from "../helpers/ApiInterface";

// // Original width, used as the expanded width
// const drawerWidth = 250;
// // ADDED: Define collapsed width
// const collapsedWidth = 80; // Adjust this value if needed for icon spacing

// let navPaneList: any = [
//     // *** Nav Pane List definition remains exactly as in your original code ***
//     {
//     id: "dashboard",
//     text: "Dashboard",
//     icon: <RiDashboardLine />,
//     clickedIcon: <RiDashboardFill />,
//     nav: "/",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//   },

//   {
//     id: "clusters",
//     text: "Clusters",
//     icon: <RiArchiveDrawerLine />,
//     clickedIcon: <RiArchiveDrawerFill />,
//     nav: "/clusters",
//     visibility: ["cluster_owner", "application_owner", "idp_admin"],
//   },
//   {
//     id: "applications",
//     text: "Applications",
//     icon: <RiArchiveStackLine />,
//     clickedIcon: <RiArchiveStackFill />,
//     nav: "/applications",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//     ],
//   },
//   {
//     id: "services",
//     text: "Services",
//     icon: <RiBubbleChartLine />,
//     clickedIcon: <RiBubbleChartFill />,
//     nav: "/services",
//     visibility: ["application_owner", "idp_admin", "developer"],
//   },
//   {
//     id: "aisolutions",
//     text: "AI Solutions",
//     icon: <RiChatVoiceLine/>,
//     clickedIcon: <RiChatVoiceFill />,
//     nav: "",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//     items:[
//       {
//         id: "aisolutions-aiagent",
//         text: "AI Agent",
//         nav: "/aisolutions/aiagent",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "aisolutions-rag",
//         text: "RAG",
//         nav: "/aisolutions/rag",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       }
//     ],
//   },
//   {
//     id: "integrations",
//     text: "Integrations",
//     icon: <RiGitMergeLine/>,
//     clickedIcon: <RiGitMergeFill />,
//     nav: "/integrations/integrations",
//     visibility: [
//       "idp_admin",
//     ],
//   },

//   {
//     id: "user-management",
//     text: "User Management",
//     icon: <RiGroupLine />,
//     clickedIcon: <RiGroupFill />,
//     nav: "/user-management",
//     visibility: ["idp_admin"],
//   },
//   {
//     id: "requests",
//     text: "Requests",
//     icon: <RiCornerDownRightLine />,
//     clickedIcon: <RiCornerDownRightLine />,
//     nav: "",
//     visibility: ["infrastructure_admin", "application_owner", "idp_admin"],
//     items: [
//       {
//         id: "requests-cluster",
//         text: "Clusters",
//         icon: <RiArchiveDrawerLine />, // Note: Original code didn't specify icons here, added based on context
//         clickedIcon: <RiArchiveDrawerFill />, // Note: Original code didn't specify icons here, added based on context
//         nav: "/requests/clusters",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-application",
//         text: "Applications",
//         icon: <RiArchiveStackLine />, // Note: Original code didn't specify icons here, added based on context
//         clickedIcon: <RiArchiveStackFill />, // Note: Original code didn't specify icons here, added based on context
//         nav: "/requests/applications",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-service",
//         text: "Services",
//         icon: <RiBubbleChartLine />, // Note: Original code didn't specify icons here, added based on context
//         clickedIcon: <RiBubbleChartFill />, // Note: Original code didn't specify icons here, added based on context
//         nav: "/requests/services",
//         visibility: ["application_owner", "idp_admin"],
//       },
//     ],
//   },
// ];

// interface HomepageProps {
//   index: string;
// }

// const MainDrawer: React.FC<HomepageProps> = ({ index }) => {
//   const { user, logoutUser } = useAuth();
//   // ADDED: Get theme for transitions
//   const theme = useTheme();
//   // ADDED: State to control drawer expansion, defaults to expanded
//   const [isExpanded, setIsExpanded] = useState(true);

//   // --- Existing User Role Filtering Logic (Unchanged) ---
//   const visibleNavPaneList = navPaneList
//     .filter((element: any) => {
//       return element.visibility.some((e: any) => user.roles.includes(e));
//     })
//     .map((element: any) => {
//       return {
//         ...element,
//         items: element.items?.filter((el: any) => {
//           return el.visibility.some((e: any) => user.roles.includes(e));
//         }),
//       };
//     });
//   // --- End of Existing Filtering Logic ---

//   const navigate = useNavigate();
//   // --- Existing State for Nested Menus and Selection (Unchanged Initialization) ---
//   const [nestedOpen, setNestedOpen] = useState<any>(
//     index.includes("-") ? { [index.split("-")[0]]: true } : {} // Keep original logic for initial open state
//   );
//   const [selectedMenu, setSelectedMenu] = useState(index);
//   // --- End of Existing State ---

//   // --- Existing Click Handlers (Unchanged) ---
//   const handleNestedClick = (name: any) => {
//     setNestedOpen((prev: any) => ({ ...prev, [name]: !prev[name] }));
//   };

//   const handleMenuSelect = (key: any) => {
//       setSelectedMenu(key);
//   };
//   // --- End of Existing Click Handlers ---

//   // ADDED: Function to toggle drawer expansion state
//   const handleToggleDrawer = () => {
//     const collapsing = isExpanded;
//     setIsExpanded(!isExpanded);
//     // Collapse nested items ONLY when the main drawer is collapsing
//     if (collapsing) {
//        setNestedOpen({});
//     }
//   };

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         // MODIFIED: Width is now dynamic based on isExpanded state
//         width: isExpanded ? drawerWidth : collapsedWidth,
//         flexShrink: 0,
//         height: "100%",
//         [`& .MuiDrawer-paper`]: {
//            // MODIFIED: Width is now dynamic based on isExpanded state
//           width: isExpanded ? drawerWidth : collapsedWidth,
//           boxSizing: "border-box",
//           backgroundColor: "black", // Original style
//           color: "white", // Original style
//           display: "flex", // Original style
//           flexDirection: "column", // Original style
//           // ADDED: Prevent content overflow and add smooth transition
//           overflowX: 'hidden',
//           transition: theme.transitions.create('width', { // Smooth width change
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.enteringScreen,
//           }),
//         },
//       }}
//     >
//       {/* Static Section - Faraday and User Details */}
//       <Box>
//          {/* --- Original Faraday Logo Section Structure --- */}
//          {/* MODIFIED: Container adjusts justification and padding based on isExpanded */}
//          <Box sx={{
//              display: "flex",
//              alignItems: "center",
//              gap: 1,
//              // MODIFIED: Justification and padding change ONLY when collapsed
//              justifyContent: isExpanded ? "start" : "center", // 'start' is original
//              paddingLeft: isExpanded ? 2 : 0, // '2' is original
//              mt: "12px" // Original style
//           }}>
//             <img
//               src="/assets/Logo.svg"
//               alt="Logo Icon"
//               style={{ width: "54px", height: "54px" }} // Original style
//             />
//             {/* ADDED: Conditionally render Faraday text */}
//             {isExpanded && (
//               <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" noWrap> {/* Original Style */}
//                 Faraday
//               </Typography>
//             )}
//           </Box>
//         {/* --- End of Original Faraday Logo Section --- */}

//         {/* --- Original User Details Section Structure (Conditional Rendering Added) --- */}
//         {user && (
//           <>
//             {/* MODIFIED: Stack adjusts alignment and marginTop ONLY when collapsed */}
//             <Stack
//                 direction="column"
//                 // MODIFIED: Keep original marginTop when expanded
//                 marginTop={isExpanded ? "-20px": "10px" } // Adjust '10px' for collapsed spacing if needed
//                 // MODIFIED: Align items center ONLY when collapsed
//                 alignItems={isExpanded ? 'flex-start' : 'center'}
//                 // ADDED: Add padding ONLY when collapsed for centering avatar
//                 sx={{ px: isExpanded ? 0 : 1}}
//              >
//               <Avatar
//                 src={user.googleProfilePicture}
//                 alt="User icon"
//                 sx={{
//                   width: "56px", // Original style
//                   height: "56px", // Original style
//                    // MODIFIED: Keep original margin/positioning when expanded
//                   marginLeft: isExpanded ? "24px" : 0, // '24px' is original
//                   position: "relative", // Original style
//                   top: isExpanded ? 39 : 20, // '39' is original, adjust '20' if needed
//                   border: "3px solid black", // Original style
//                   // ADDED: Add margin-bottom ONLY when collapsed for spacing
//                   mb: isExpanded ? 0 : 2,
//                 }}
//               />
//               {/* ADDED: Conditionally render the original details Box */}
//               {isExpanded && (
//                   <Box
//                     sx={{
//                       backgroundColor: "#212121",  // Original style
//                       borderRadius: "8px", // Original style
//                       padding: "10px", // Original style
//                       margin: "20px", // Original style
//                       display: "flex", // Original style
//                       flexDirection: "column" // Original style
//                     }}
//                   >
//                     <Typography fontFamily="Gilroy-Bold" fontSize="16px" marginTop="10px" marginLeft="4px"> {/* Original Style */}
//                       {user.name}
//                     </Typography>
//                     <Grid container gap={0.5} mt={0.5}> {/* Original Style */}
//                       {user.roles?.map((e: string, idx: number) => ( // Added index for key
//                         <Grid item key={`${e}-${idx}`}> {/* Use unique key */}
//                           <Paper
//                             elevation={3} // Original style
//                             sx={{
//                               borderRadius: 10, // Original style
//                               backgroundColor: "#555", // Original style
//                             }}
//                           >
//                             <Box px={1}> {/* Original Style */}
//                             <Typography fontSize="10px" fontFamily="Gilroy-Regular" color="#fff"> {/* Original Style */}
//                               {nameRoleObj[e]}
//                             </Typography>
//                             </Box>
//                           </Paper>
//                         </Grid>
//                       ))}
//                     </Grid>
//                   </Box>
//                )}
//             </Stack>
//             {/* ADDED: Conditionally render the original divider */}
//             {isExpanded && (
//               <Divider
//                   color="#181818" // Original style
//                   sx={{ marginTop: "8px", marginBottom: "8px", mx: "16px" }} // Original style
//               />
//              )}
//             </>
//         )}
//         {/* --- End of Original User Details Section --- */}
//       </Box>

//       {/* Scrollable Navigation List */}
//       {/* MODIFIED: Container Box pushes content below it down */}
//       <Box sx={{ overflowY: "auto", flex: 1 }}>
//         {/* --- Original List Structure --- */}
//         <List sx={{ px: "8px", mx: "8px" }}> {/* Original Style */}
//           {visibleNavPaneList.map((menu: any) => (
//             <React.Fragment key={menu.id}>
//               <ListItem
//                 component="div" // Original prop
//                 onClick={() => {
//                   // --- Original onClick Logic ---
//                   if (menu.items?.length) {
//                     // Prevent opening nested lists when collapsed
//                     if (isExpanded) {
//                       handleNestedClick(menu.id);
//                     }
//                   } else {
//                     handleMenuSelect(menu.id);
//                   }
//                   if (menu.nav) navigate(menu.nav);
//                   // --- End of Original onClick Logic ---
//                 }}
//                 sx={{
//                   cursor: "pointer", // Original style
//                   borderRadius: "8px", // Original style
//                   // --- Original Background/Color Logic (Unchanged) ---
//                   backgroundColor: menu.id === selectedMenu ? "#fff" : "#000",
//                   color: menu.id === selectedMenu ? "#000" : "#fff",
//                   // --- End of Original Background/Color Logic ---
//                   // MODIFIED: Adjust justification ONLY when collapsed
//                   justifyContent: isExpanded ? 'flex-start' : 'center', // 'flex-start' is implied default
//                   // ADDED: Adjust padding slightly ONLY when collapsed if needed for icon centering
//                   px: isExpanded ? undefined : 1.5, // Keeps original padding rule when expanded
//                 }}
//               >
//                 <ListItemIcon sx={{
//                     // --- Original Color Logic (Unchanged) ---
//                     color: menu.id === selectedMenu ? "#000" : "#fff",
//                     minWidth: "unset", // Original style
//                     // MODIFIED: Adjust margin ONLY when collapsed
//                     mr: isExpanded ? 1 : 0 // '1' is original
//                  }}>
//                    {/* --- Original Icon Logic (Unchanged) --- */}
//                   {menu.id === selectedMenu ? menu.clickedIcon : menu.icon}
//                 </ListItemIcon>
//                 {/* ADDED: Conditionally render original ListItemText */}
//                 {isExpanded && (
//                   <ListItemText> {/* Original Structure */}
//                     <Typography fontFamily="Gilroy-Bold" fontSize="14px">{menu.text}</Typography> {/* Original Style */}
//                   </ListItemText>
//                 )}
//                 {/* ADDED: Conditionally render original Expand/Collapse icons */}
//                 {isExpanded && menu.items?.length > 0 && (nestedOpen[menu.id] ? <ExpandLess /> : <ExpandMore />)} {/* Original Logic/Icons */}
//               </ListItem>

//               {/* Nested Menu Items */}
//               {/* ADDED: Conditionally render the original Collapse section */}
//               {isExpanded && menu.items?.length > 0 && (
//                 <Collapse in={nestedOpen[menu.id]} timeout="auto" unmountOnExit> {/* Original Component/Props */}
//                   <List sx={{ mx: 2 }}> {/* Original Style */}
//                     {menu.items.map((item: any) => (
//                       <ListItem
//                         key={item.id} // Original prop
//                         onClick={() => {
//                           // --- Original onClick Logic ---
//                           handleMenuSelect(item.id);
//                           if (item.nav) navigate(item.nav);
//                           // --- End of Original onClick Logic ---
//                         }}
//                         sx={{
//                           cursor: "pointer", // Original style
//                           borderRadius: "8px", // Original style
//                           // --- Original Background/Color Logic (Unchanged) ---
//                           backgroundColor: item.id === selectedMenu ? "#fff" : "#000",
//                           color: item.id === selectedMenu ? "#000" : "#fff",
//                           // --- End of Original Background/Color Logic ---
//                         }}
//                       >
//                         {/* ADDED: Conditionally render original ListItemText */}
//                         {isExpanded && (
//                             <ListItemText> {/* Original Structure */}
//                               <Typography fontFamily="Gilroy-Bold" fontSize="14px">{item.text}</Typography> {/* Original Style */}
//                             </ListItemText>
//                         )}
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Collapse>
//               )}
//             </React.Fragment>
//           ))}
//         </List>
//         {/* --- End of Original List Structure --- */}
//       </Box>

//       {/* Static Section - Toggle Button and Sign Out Button */}
//       {/* ADDED: Container Box to push toggle/signout to bottom */}
//       <Box sx={{ mt: 'auto', width: '100%' }}>

//         {/* ADDED: Toggle Button - Placed above the original sign out section */}
//          <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
//            <IconButton
//              onClick={handleToggleDrawer}
//              sx={{
//                color: 'white', // Basic styling for visibility
//                border: '1px solid #555', // Optional border
//                '&:hover': { bgcolor: '#333' } // Basic hover feedback
//              }}
//              aria-label={isExpanded ? "Collapse drawer" : "Expand drawer"}
//            >
//              {/* ADDED: Icon changes based on state */}
//              {isExpanded ? <ChevronLeftIcon /> : <ChevronRightIcon />}
//            </IconButton>
//          </Box>

//         {/* --- Original Sign Out Section Structure --- */}
//         {/* MODIFIED: Outer Box's paddingLeft is handled by Button's padding now */}
//         <Box sx={{
//             display: "flex", // Original style
//             alignItems: "center", // Original style
//             gap: 1, // Original style
//             // justifyContent: "start", // Modified below on Button instead
//             // paddingLeft: 2, // Modified below on Button instead
//             mt: "12px", // Original style
//             // width: "80%", // Let Button take fullWidth
//             }}>
//             <Divider sx={{ bgcolor: "#212121", flexGrow: isExpanded ? 0 : 1, mx: isExpanded ? 1 : 0 }} /> {/* Divider adjusted */}
//             <Button
//               fullWidth // Original prop
//               variant="text" // Original prop
//               sx={{
//                 backgroundColor: "black", // Original style
//                 color: "white", // Original style
//                 fontWeight: "bold", // Original style
//                 display: "flex", // Original style
//                  // MODIFIED: Justification adjusts ONLY when collapsed
//                 justifyContent: isExpanded ? "flex-start" : "center", // 'flex-start' is original
//                 alignItems: "center", // Original style
//                 "&:hover": { backgroundColor: "#212121", color: "white" ,}, // Original style
//                 textTransform: "none", // Original style
//                 pb: "16px", // Original style
//                 pt: "12px", // Original style
//                 mt: "8px", // Original style
//                 // ADDED: Apply horizontal padding ONLY when expanded to mimic original paddingLeft=2
//                 px: isExpanded ? 2 : 0,
//               }}
//               onClick={() => {
//                 // --- Original onClick Logic ---
//                 logoutUser();
//                 navigate("/login");
//                 // --- End of Original onClick Logic ---
//               }}
//             >
//               <RiLogoutCircleRLine /> {/* Original Icon */}
//               {/* ADDED: Conditionally render original Sign Out text */}
//               {isExpanded && (
//                 <Typography fontFamily="Gilroy-Regular" fontSize="14px" ml="8px" color="#FFFFFF"> {/* Original Style */}
//                   Sign Out
//                 </Typography>
//               )}
//             </Button>
//              {/* ADDED: Need a matching divider on the right when expanded if the original Box didn't span full width */}
//              {isExpanded && <Divider sx={{ bgcolor: "#212121", flexGrow: 0, mx: 1 }} />}
//         </Box>
//          {/* --- End of Original Sign Out Section --- */}
//       </Box>
//     </Drawer>
//   );
// };
// export default MainDrawer;

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Toolbar,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   Typography,
//   Divider,
//   Avatar,
//   Stack,
//   Button,
//   Collapse,
//   Grid,
//   Paper,
//   IconButton, // <-- Add IconButton
//   useTheme, 
// } from "@mui/material";
// import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
// import { RiLogoutCircleRLine } from "react-icons/ri";
// import { RiDashboardLine } from "react-icons/ri";
// import { RiArchiveDrawerLine } from "react-icons/ri";
// import { RiGroupLine } from "react-icons/ri";
// import { RiArchiveStackLine } from "react-icons/ri";
// import { RiBubbleChartLine } from "react-icons/ri";
// import { RiCornerDownRightLine } from "react-icons/ri";
// import { RiChatVoiceLine,RiChatVoiceFill} from 'react-icons/ri';
// import { RiGroupFill } from "react-icons/ri";
// import { RiArchiveDrawerFill } from "react-icons/ri";
// import { RiDashboardFill } from "react-icons/ri";
// import { RiArchiveStackFill } from "react-icons/ri";
// import { RiBubbleChartFill } from "react-icons/ri";
// import {RiGitMergeLine, RiGitMergeFill} from "react-icons/ri"
// import { useAuth } from "../helpers/AuthProvider";
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'; // <-- Add ChevronLeftIcon
// import ChevronRightIcon from '@mui/icons-material/ChevronRight'; // <-- Add ChevronRightIcon
// import { nameRoleObj } from "../helpers/RoleHelper";
// import { ExpandLess, ExpandMore, Visibility } from "@mui/icons-material";
// import queryGraphql from "../helpers/ApiInterface";

// const drawerWidth = 250;

// let navPaneList: any = [
//   {
//     id: "dashboard",
//     text: "Dashboard",
//     icon: <RiDashboardLine />,
//     clickedIcon: <RiDashboardFill />,
//     nav: "/",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//   },

//   {
//     id: "clusters",
//     text: "Clusters",
//     icon: <RiArchiveDrawerLine />,
//     clickedIcon: <RiArchiveDrawerFill />,
//     nav: "/clusters",
//     visibility: ["cluster_owner", "application_owner", "idp_admin"],
//   },
//   {
//     id: "applications",
//     text: "Applications",
//     icon: <RiArchiveStackLine />,
//     clickedIcon: <RiArchiveStackFill />,
//     nav: "/applications",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//     ],
//   },
//   {
//     id: "services",
//     text: "Services",
//     icon: <RiBubbleChartLine />,
//     clickedIcon: <RiBubbleChartFill />,
//     nav: "/services",
//     visibility: ["application_owner", "idp_admin", "developer"],
//   },
//   {
//     id: "aisolutions",
//     text: "AI Solutions",
//     icon: <RiChatVoiceLine/>,
//     clickedIcon: <RiChatVoiceFill />,
//     nav: "",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//     items:[
//       {
//         id: "aisolutions-aiagent",
//         text: "AI Agent",
//         nav: "/aisolutions/aiagent",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "aisolutions-rag",
//         text: "RAG",
//         nav: "/aisolutions/rag",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       }
//     ],
//   },
//   {
//     id: "integrations",
//     text: "Integrations",
//     icon: <RiGitMergeLine/>,
//     clickedIcon: <RiGitMergeFill />,
//     nav: "/integrations/integrations",
//     visibility: [
//       "idp_admin",
//     ],
//   },
  
//   {
//     id: "user-management",
//     text: "User Management",
//     icon: <RiGroupLine />,
//     clickedIcon: <RiGroupFill />,
//     nav: "/user-management",
//     visibility: ["idp_admin"],
//   },
//   {
//     id: "requests",
//     text: "Requests",
//     icon: <RiCornerDownRightLine />,
//     clickedIcon: <RiCornerDownRightLine />,
//     nav: "",
//     visibility: ["infrastructure_admin", "application_owner", "idp_admin"],
//     items: [
//       {
//         id: "requests-cluster",
//         text: "Clusters",
//         icon: <RiArchiveDrawerLine />,
//         clickedIcon: <RiArchiveDrawerFill />,
//         nav: "/requests/clusters",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-application",
//         text: "Applications",
//         icon: <RiArchiveStackLine />,
//         clickedIcon: <RiArchiveStackFill />,
//         nav: "/requests/applications",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-service",
//         text: "Services",
//         icon: <RiBubbleChartLine />,
//         clickedIcon: <RiBubbleChartFill />,
//         nav: "/requests/services",
//         visibility: ["application_owner", "idp_admin"],
//       },
//     ],
//   },
  
// ];

// interface HomepageProps {
//   index: string;
// }

// const MainDrawer: React.FC<HomepageProps> = ({ index }) => {
//   const { user, logoutUser } = useAuth();
  
//   const theme = useTheme(); // <-- Get theme
//   const expandedWidth = 250; // <-- Define expanded width
//   const collapsedWidth = 80; // <-- Define collapsed width (adjust as needed)
//   const [isExpanded, setIsExpanded] = useState(true); // <-- Add state for expansion

//   navPaneList = navPaneList.filter((element: any) => {
//     return element.visibility.some((e: any) => user.roles.includes(e));
//   });
//   navPaneList = navPaneList.map((element: any) => {
//     return {
//       ...element,
//       items: element.items?.filter((el: any) => {
//         return el.visibility.some((e: any) => user.roles.includes(e));
//       }),
//     };
//   });

//   const navigate = useNavigate();
//   // const [selectedIndex, setSelectedIndex] = useState(index);
//   const [nestedOpen, setNestedOpen] = useState<any>(
//     index.includes("-") ? { index: true, [index.split("-")[0]]: true } : {}
//   );
//   const [selectedMenu, setSelectedMenu] = useState(index);

//   const handleNestedClick = (name: any) => {
//     setNestedOpen((prev: any) => ({ ...prev, [name]: !prev[name] }));
//   };

//   const handleMenuSelect = (key: any) => {
//     //setSelectedMenu(key);
//       setSelectedMenu(key);
//   };
//    // Function to toggle expansion
//     const handleToggleDrawer = () => {
//         setIsExpanded(!isExpanded);
//         // Optionally collapse nested menus when collapsing the main drawer
//         if (isExpanded) {
//           setNestedOpen({});
//         }
//     };
//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         // width: drawerWidth,
//         width: isExpanded ? expandedWidth : collapsedWidth, // <-- Use dynamic width
//         flexShrink: 0,
//         height: "100%",
//         [`& .MuiDrawer-paper`]: {
//           // width: drawerWidth,
//           width: isExpanded ? expandedWidth : collapsedWidth, // <-- Use dynamic width
//           boxSizing: "border-box",
//           backgroundColor: "black",
//           color: "white",
//           display: "flex",
//           flexDirection: "column",
//           overflowX: 'hidden', // <-- Prevent horizontal scrollbar during transition
//           transition: theme.transitions.create('width', { // <-- Add smooth transition
//           easing: theme.transitions.easing.sharp,
//           duration: theme.transitions.duration.enteringScreen,
//          }),
//         },
//       }}
//     >
//       {/* Static Section - Faraday and User Details */}
//       <Box>
//         {/* <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "start",
//             paddingLeft: 2,
//             minHeight: "32px",
//           }}
//         > */}
//           {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "start", paddingLeft: 2, mt: "12px"}}> */}
//           <Box sx={{
//             display: "flex",
//             alignItems: "center",
//             gap: 1,
//             justifyContent: isExpanded ? "start" : "center", // <-- Center when collapsed
//             paddingLeft: isExpanded ? 2 : 0, // <-- Adjust padding
//             mt: "12px",
//             minHeight: '54px' // Ensure height consistency
//           }}>
//             <img
//               src="/assets/Logo.svg"
//               alt="Logo Icon"
//               style={{ width: "54px", height: "54px" }}
//             />
//                      {isExpanded && ( // <-- Conditionally render text
//             <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" noWrap>
//               Faraday
//             </Typography>
//          )}
//             {/* <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" noWrap>
//               Faraday
//             </Typography> */}
//           </Box>
//         {/* </Box> */}
//         {user && (
//           <>
//             {/* <Stack direction="column" marginTop="-20px"> */}
//             <Stack direction="column" alignItems={isExpanded ? "flex-start" : "center"} sx={{px: isExpanded ? 0 : 1}}> {/* Center avatar when collapsed */}
//               <Avatar
//                 src={user.googleProfilePicture}
//                 alt="User icon"
//                 sx={{
//                   width: "56px",
//                   height: "56px",
//                   // marginLeft: "24px",
//                   marginLeft: isExpanded ? "24px" : 0, // <-- Adjust margin
//                   position: "relative",
//                   top: 39,
//                   border: "3px solid black",
//                 }}
//               />
//               {/* Added a box with a light gray background */}
//               {isExpanded && ( // <-- Conditionally render details box
//               <Box
//                 sx={{
//                   backgroundColor: "#212121",  // Light gray background
//                   borderRadius: "8px",
//                   padding: "10px",
//                   margin: "20px",
//                   display: "flex",
//                   flexDirection: "column"
//                 }}
//               >
//                 <Typography fontFamily="Gilroy-Bold" fontSize="16px" marginTop="10px" marginLeft="4px">
//                   {user.name}
//                 </Typography>
//                 <Grid container gap={0.5} mt={0.5}>
//                   {user.roles?.map((e: string) => (
//                     <Grid item>
//                       <Paper
//                         elevation={3}
//                         sx={{
//                           borderRadius: 10,
//                           backgroundColor: "#555",
//                           // padding: "4px",
//                         }}
//                       >
//                         <Box px={1}>
//                         <Typography fontSize="10px" fontFamily="Gilroy-Regular" color="#fff">
//                           {nameRoleObj[e]}
//                         </Typography>

//                         </Box>
                        
//                       </Paper>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Box>
//               )}
//             </Stack>
//             {isExpanded && (
//             <Divider
//                 color="#181818"
//                 sx={{ marginTop: "8px", marginBottom: "8px", mx: "16px" }}
//               /> 
//                      )}         </>
//         )}
//       </Box>
//       {/* Scrollable Navigation List */}
//       <Box sx={{ overflowY: "auto", flex: 1 }}>
//         <List sx={{ px: "8px", mx: "8px" }}>
//           {navPaneList.map((menu: any) => (
//             <React.Fragment key={menu.id}>
//               <ListItem
//                 component="div"
//                 onClick={() => {
//                   if (menu.items?.length) {
//                     handleNestedClick(menu.id);
//                   } else {
//                     handleMenuSelect(menu.id);
//                   }
//                   if (menu.nav) navigate(menu.nav);
//                 }}
//                 sx={{
//                   cursor: "pointer",
//                   borderRadius: "8px",
//                   backgroundColor: menu.id === selectedMenu ? "#fff" : "#000",
//                   color: menu.id === selectedMenu ? "#000" : "#fff",
//                   justifyContent: isExpanded ? 'initial' : 'center', // Center content when collapsed
//                   px: isExpanded ? 2 : 1.5, // Adjust padding
//                 }}
//               >
//                 <ListItemIcon 
//                 sx={{ 
//                   color: menu.id === selectedMenu ? "#000" : "#fff", 
//                   minWidth: "unset", 
//                   // mr:1
//                   mr: isExpanded ? 1 : 0 // Remove margin when collapsed
//                  }}>
//                   {menu.id === selectedMenu ? menu.clickedIcon : menu.icon}
//                 </ListItemIcon>
//                 {isExpanded && (
//                 <ListItemText>
//                   <Typography fontFamily="Gilroy-Bold" fontSize="14px">{menu.text}</Typography>
//                 </ListItemText>
//                 )}
//                 {/* Only show expand/collapse arrows if drawer is expanded */}
//               {isExpanded && menu.items?.length > 0 && (nestedOpen[menu.id] ? <ExpandLess /> : <ExpandMore />)}
//                 {/* {menu.items?.length > 0 && (nestedOpen[menu.id] ? <ExpandLess /> : <ExpandMore />)} */}
//               </ListItem>
//               {/* Nested Menu Items */}
//               {isExpanded && menu.items?.length > 0 && (
//                 <Collapse in={nestedOpen[menu.id]} timeout="auto" unmountOnExit>
//                   <List sx={{ mx: 2 }}>
//                     {menu.items.map((item: any) => (
//                       <ListItem
//                         key={item.id}
//                         onClick={() => {
//                           handleMenuSelect(item.id);
//                           if (item.nav) navigate(item.nav);
//                         }}
//                         sx={{
//                           cursor: "pointer",
//                           borderRadius: "8px",
//                           backgroundColor: item.id === selectedMenu ? "#fff" : "#000",
//                           color: item.id === selectedMenu ? "#000" : "#fff",
//                           pl: 1, // Adjust padding for nested items
//                          '&:hover': { // Add subtle hover for non-selected items
//                             backgroundColor: item.id === selectedMenu ? '#fff' : '#212121'
//                          }
//                         }}
//                       >
//                       {/* Removed icon for nested items as per original code, but kept text conditional */}
//                        {isExpanded && ( // <-- Conditionally render text
//                           <ListItemText>
//                             <Typography fontFamily="Gilroy-Bold" fontSize="14px">{item.text}</Typography>
//                           </ListItemText>
//                        )}
//                         {/* <ListItemText>
//                           <Typography fontFamily="Gilroy-Bold" fontSize="14px">{item.text}</Typography>
//                         </ListItemText> */}
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Collapse>
//               )}
//             </React.Fragment>
//           ))}
//         </List>
//       </Box>
//       <Box sx={{
//         // position: 'sticky', // Optional: If you want it always visible even if list is long
//         // bottom: 0,
//         // bgcolor: 'black', // Match background
//         mt: 'auto', // Pushes this Box to the bottom
//         pt: 1, // Add some padding top
//         width: '100%' // Ensure it takes full width for centering
//       }}>
//         {/* Toggle Button */}
//          <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
//            <IconButton
//              onClick={handleToggleDrawer}
//              sx={{
//                color: 'white',
//                border: '1px solid #555', // Optional border
//                '&:hover': { bgcolor: '#333' }
//              }}
//            >
//              {isExpanded ? <ChevronLeftIcon /> : <ChevronRightIcon />}
//            </IconButton>
//          </Box>

//         {/* Sign Out Button */}
//        <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "start", paddingLeft: 2, mt: "12px", width: "80%"}}>
//        <Divider sx={{ bgcolor: "#212121" }} />
//        <Divider sx={{ bgcolor: "#212121", mx: isExpanded ? 2 : 1 }} /> {/* Adjust divider margin */}
//         <Button
//           fullWidth
//           variant="text"
//           sx={{
//             backgroundColor: "black",
//             color: "white",
//             fontWeight: "bold",
//             display: "flex",
//           //  justifyContent: "flex-start",
//            justifyContent: isExpanded ? "flex-start" : "center", // Center icon when collapsed
//             alignItems: "center",
//             "&:hover": { backgroundColor: "#212121", color: "white" },
//             textTransform: "none",
//             pb: "16px",
//             pt: "12px",
//             mt: "8px",
//            px: isExpanded ? 2 : 0, // Adjust padding
//           }}
//           onClick={() => {
//             logoutUser();
//             navigate("/login");
//           }}
//         >
//           <RiLogoutCircleRLine size={isExpanded ? 20 : 24} /> {/* Slightly larger icon when collapsed? Optional. */}
//          {isExpanded && ( // <-- Conditionally render text
//             <Typography fontFamily="Gilroy-Regular" fontSize="14px" ml="8px" color="#FFFFFF">
//               Sign Out
//             </Typography>
//          )}
//         </Button>
//        </Box>
//        {/* Removed the outer Box that limited width */}
//       </Box>
//       {/* Static Section - Sign Out Button */}
//       {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "start", paddingLeft: 2, mt: "12px", width: "80%"}}>
//         <Divider sx={{ bgcolor: "#212121" }} />
//         <Button
//           fullWidth
//           variant="text"
//           sx={{
//             backgroundColor: "black",
//             color: "white",
//             fontWeight: "bold",
//             display: "flex",
//             justifyContent: "flex-start",
//             alignItems: "center",
//             "&:hover": { backgroundColor: "#212121", color: "white" ,},
//             textTransform: "none",
//             pb: "16px",
//             pt: "12px",
//             mt: "8px",
//             // borderRadius: "8px",
//           }}
//           onClick={() => {
//             logoutUser();
//             navigate("/login");
//           }}
//         >
//           <RiLogoutCircleRLine />
//           <Typography fontFamily="Gilroy-Regular" fontSize="14px" ml="8px" color="#FFFFFF">
//             Sign Out
//           </Typography>
//         </Button>
//       </Box> */}
//     </Drawer>
//   );
// };
// export default MainDrawer;
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Toolbar,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   Typography,
//   Divider,
//   Avatar,
//   Stack,
//   Button,
//   Collapse,
//   Grid,
//   Paper,
// } from "@mui/material";
// import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
// import { RiLogoutCircleRLine } from "react-icons/ri";
// import { RiDashboardLine } from "react-icons/ri";
// import { RiArchiveDrawerLine } from "react-icons/ri";
// import { RiGroupLine } from "react-icons/ri";
// import { RiArchiveStackLine } from "react-icons/ri";
// import { RiBubbleChartLine } from "react-icons/ri";
// import { RiCornerDownRightLine } from "react-icons/ri";
// import { RiChatVoiceLine,RiChatVoiceFill} from 'react-icons/ri';
// import { RiGroupFill } from "react-icons/ri";
// import { RiArchiveDrawerFill } from "react-icons/ri";
// import { RiDashboardFill } from "react-icons/ri";
// import { RiArchiveStackFill } from "react-icons/ri";
// import { RiBubbleChartFill } from "react-icons/ri";
// import {RiGitMergeLine, RiGitMergeFill} from "react-icons/ri"
// import { useAuth } from "../helpers/AuthProvider";

// import { nameRoleObj } from "../helpers/RoleHelper";
// import { ExpandLess, ExpandMore, Visibility } from "@mui/icons-material";
// import queryGraphql from "../helpers/ApiInterface";

// const drawerWidth = 250;

// let navPaneList: any = [
//   {
//     id: "dashboard",
//     text: "Dashboard",
//     icon: <RiDashboardLine />,
//     clickedIcon: <RiDashboardFill />,
//     nav: "/",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//   },

//   {
//     id: "clusters",
//     text: "Clusters",
//     icon: <RiArchiveDrawerLine />,
//     clickedIcon: <RiArchiveDrawerFill />,
//     nav: "/clusters",
//     visibility: ["cluster_owner", "application_owner", "idp_admin"],
//   },
//   {
//     id: "applications",
//     text: "Applications",
//     icon: <RiArchiveStackLine />,
//     clickedIcon: <RiArchiveStackFill />,
//     nav: "/applications",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//     ],
//   },
//   {
//     id: "services",
//     text: "Services",
//     icon: <RiBubbleChartLine />,
//     clickedIcon: <RiBubbleChartFill />,
//     nav: "/services",
//     visibility: ["application_owner", "idp_admin", "developer"],
//   },
//   {
//     id: "aisolutions",
//     text: "AI Solutions",
//     icon: <RiChatVoiceLine/>,
//     clickedIcon: <RiChatVoiceFill />,
//     nav: "",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//     items:[
//       {
//         id: "aisolutions-aiagent",
//         text: "AI Agent",
//         nav: "/aisolutions/aiagent",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "aisolutions-rag",
//         text: "RAG",
//         nav: "/aisolutions/rag",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       }
//     ],
//   },
//   {
//     id: "integrations",
//     text: "Integrations",
//     icon: <RiGitMergeLine/>,
//     clickedIcon: <RiGitMergeFill />,
//     nav: "/integrations/integrations",
//     visibility: [
//       "idp_admin",
//     ],
//   },
  
//   {
//     id: "user-management",
//     text: "User Management",
//     icon: <RiGroupLine />,
//     clickedIcon: <RiGroupFill />,
//     nav: "/user-management",
//     visibility: ["idp_admin"],
//   },
//   {
//     id: "requests",
//     text: "Requests",
//     icon: <RiCornerDownRightLine />,
//     clickedIcon: <RiCornerDownRightLine />,
//     nav: "",
//     visibility: ["infrastructure_admin", "application_owner", "idp_admin"],
//     items: [
//       {
//         id: "requests-cluster",
//         text: "Clusters",
//         icon: <RiArchiveDrawerLine />,
//         clickedIcon: <RiArchiveDrawerFill />,
//         nav: "/requests/clusters",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-application",
//         text: "Applications",
//         icon: <RiArchiveStackLine />,
//         clickedIcon: <RiArchiveStackFill />,
//         nav: "/requests/applications",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-service",
//         text: "Services",
//         icon: <RiBubbleChartLine />,
//         clickedIcon: <RiBubbleChartFill />,
//         nav: "/requests/services",
//         visibility: ["application_owner", "idp_admin"],
//       },
//     ],
//   },
  
// ];

// interface HomepageProps {
//   index: string;
// }

// const MainDrawer: React.FC<HomepageProps> = ({ index }) => {
//   const { user, logoutUser } = useAuth();
//   navPaneList = navPaneList.filter((element: any) => {
//     return element.visibility.some((e: any) => user.roles.includes(e));
//   });
//   navPaneList = navPaneList.map((element: any) => {
//     return {
//       ...element,
//       items: element.items?.filter((el: any) => {
//         return el.visibility.some((e: any) => user.roles.includes(e));
//       }),
//     };
//   });

//   const navigate = useNavigate();
//   // const [selectedIndex, setSelectedIndex] = useState(index);
//   const [nestedOpen, setNestedOpen] = useState<any>(
//     index.includes("-") ? { index: true, [index.split("-")[0]]: true } : {}
//   );
//   const [selectedMenu, setSelectedMenu] = useState(index);

//   const handleNestedClick = (name: any) => {
//     setNestedOpen((prev: any) => ({ ...prev, [name]: !prev[name] }));
//   };

//   const handleMenuSelect = (key: any) => {
//     //setSelectedMenu(key);
//       setSelectedMenu(key);
//   };

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: drawerWidth,
//         flexShrink: 0,
//         height: "100%",
//         [`& .MuiDrawer-paper`]: {
//           width: drawerWidth,
//           boxSizing: "border-box",
//           backgroundColor: "black",
//           color: "white",
//           display: "flex",
//           flexDirection: "column",
//         },
//       }}
//     >
//       {/* Static Section - Faraday and User Details */}
//       <Box>
//         {/* <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "start",
//             paddingLeft: 2,
//             minHeight: "32px",
//           }}
//         > */}
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "start", paddingLeft: 2, mt: "12px"}}>
//             <img
//               src="/assets/Logo.svg"
//               alt="Logo Icon"
//               style={{ width: "54px", height: "54px" }}
//             />
//             <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" noWrap>
//               Faraday
//             </Typography>
//           </Box>
//         {/* </Box> */}
//         {user && (
//           <>
//             <Stack direction="column" marginTop="-20px">
//               <Avatar
//                 src={user.googleProfilePicture}
//                 alt="User icon"
//                 sx={{
//                   width: "56px",
//                   height: "56px",
//                   marginLeft: "24px",
//                   position: "relative",
//                   top: 39,
//                   border: "3px solid black",
//                 }}
//               />
//               {/* Added a box with a light gray background */}
//               <Box
//                 sx={{
//                   backgroundColor: "#212121",  // Light gray background
//                   borderRadius: "8px",
//                   padding: "10px",
//                   margin: "20px",
//                   display: "flex",
//                   flexDirection: "column"
//                 }}
//               >
//                 <Typography fontFamily="Gilroy-Bold" fontSize="16px" marginTop="10px" marginLeft="4px">
//                   {user.name}
//                 </Typography>
//                 <Grid container gap={0.5} mt={0.5}>
//                   {user.roles?.map((e: string) => (
//                     <Grid item>
//                       <Paper
//                         elevation={3}
//                         sx={{
//                           borderRadius: 10,
//                           backgroundColor: "#555",
//                           // padding: "4px",
//                         }}
//                       >
//                         <Box px={1}>
//                         <Typography fontSize="10px" fontFamily="Gilroy-Regular" color="#fff">
//                           {nameRoleObj[e]}
//                         </Typography>

//                         </Box>
                        
//                       </Paper>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Box>
//             </Stack>
//             <Divider
//                 color="#181818"
//                 sx={{ marginTop: "8px", marginBottom: "8px", mx: "16px" }}
//               />          </>
//         )}
//       </Box>
//       {/* Scrollable Navigation List */}
//       <Box sx={{ overflowY: "auto", flex: 1 }}>
//         <List sx={{ px: "8px", mx: "8px" }}>
//           {navPaneList.map((menu: any) => (
//             <React.Fragment key={menu.id}>
//               <ListItem
//                 component="div"
//                 onClick={() => {
//                   if (menu.items?.length) {
//                     handleNestedClick(menu.id);
//                   } else {
//                     handleMenuSelect(menu.id);
//                   }
//                   if (menu.nav) navigate(menu.nav);
//                 }}
//                 sx={{
//                   cursor: "pointer",
//                   borderRadius: "8px",
//                   backgroundColor: menu.id === selectedMenu ? "#fff" : "#000",
//                   color: menu.id === selectedMenu ? "#000" : "#fff",
//                 }}
//               >
//                 <ListItemIcon sx={{ color: menu.id === selectedMenu ? "#000" : "#fff", minWidth: "unset", mr: 1 }}>
//                   {menu.id === selectedMenu ? menu.clickedIcon : menu.icon}
//                 </ListItemIcon>
//                 <ListItemText>
//                   <Typography fontFamily="Gilroy-Bold" fontSize="14px">{menu.text}</Typography>
//                 </ListItemText>
//                 {menu.items?.length > 0 && (nestedOpen[menu.id] ? <ExpandLess /> : <ExpandMore />)}
//               </ListItem>
//               {/* Nested Menu Items */}
//               {menu.items?.length > 0 && (
//                 <Collapse in={nestedOpen[menu.id]} timeout="auto" unmountOnExit>
//                   <List sx={{ mx: 2 }}>
//                     {menu.items.map((item: any) => (
//                       <ListItem
//                         key={item.id}
//                         onClick={() => {
//                           handleMenuSelect(item.id);
//                           if (item.nav) navigate(item.nav);
//                         }}
//                         sx={{
//                           cursor: "pointer",
//                           borderRadius: "8px",
//                           backgroundColor: item.id === selectedMenu ? "#fff" : "#000",
//                           color: item.id === selectedMenu ? "#000" : "#fff",
//                         }}
//                       >
//                         <ListItemText>
//                           <Typography fontFamily="Gilroy-Bold" fontSize="14px">{item.text}</Typography>
//                         </ListItemText>
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Collapse>
//               )}
//             </React.Fragment>
//           ))}
//         </List>
//       </Box>
//       {/* Static Section - Sign Out Button */}
//       <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "start", paddingLeft: 2, mt: "12px", width: "80%"}}>
//         <Divider sx={{ bgcolor: "#212121" }} />
//         <Button
//           fullWidth
//           variant="text"
//           sx={{
//             backgroundColor: "black",
//             color: "white",
//             fontWeight: "bold",
//             display: "flex",
//             justifyContent: "flex-start",
//             alignItems: "center",
//             "&:hover": { backgroundColor: "#212121", color: "white" ,},
//             textTransform: "none",
//             pb: "16px",
//             pt: "12px",
//             mt: "8px",
//             // borderRadius: "8px",
//           }}
//           onClick={() => {
//             logoutUser();
//             navigate("/login");
//           }}
//         >
//           <RiLogoutCircleRLine />
//           <Typography fontFamily="Gilroy-Regular" fontSize="14px" ml="8px" color="#FFFFFF">
//             Sign Out
//           </Typography>
//         </Button>
//       </Box>
//     </Drawer>
//   );
// };
// export default MainDrawer;


// import React, { useState, useMemo } from "react"; // Import useMemo
// import { useNavigate } from "react-router-dom";
// import {
//   Toolbar,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   Typography,
//   Divider,
//   Avatar,
//   Stack,
//   Button,
//   Collapse,
//   Grid,
//   Paper,
//   IconButton,
//   useTheme,
// } from "@mui/material";
// // Icon Imports (ensure these paths are correct)
// import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
// import { RiLogoutCircleRLine } from "react-icons/ri";
// import { RiDashboardLine } from "react-icons/ri";
// import { RiArchiveDrawerLine } from "react-icons/ri";
// import { RiGroupLine } from "react-icons/ri";
// import { RiArchiveStackLine } from "react-icons/ri";
// import { RiBubbleChartLine } from "react-icons/ri";
// import { RiCornerDownRightLine } from "react-icons/ri";
// import { RiChatVoiceLine,RiChatVoiceFill} from 'react-icons/ri';
// import { RiGroupFill } from "react-icons/ri";
// import { RiArchiveDrawerFill } from "react-icons/ri";
// import { RiDashboardFill } from "react-icons/ri";
// import { RiArchiveStackFill } from "react-icons/ri";
// import { RiBubbleChartFill } from "react-icons/ri";
// import {RiGitMergeLine, RiGitMergeFill} from "react-icons/ri"
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import MenuOpenIcon from '@mui/icons-material/MenuOpen';
// import { ExpandLess, ExpandMore, Visibility } from "@mui/icons-material";

// // Helper Imports (ensure these paths are correct)
// import { useAuth } from "../helpers/AuthProvider";
// import { nameRoleObj } from "../helpers/RoleHelper";

// // --- Type Definitions ---
// interface BaseNavItem {
//   id: string;
//   text: string;
//   icon?: React.ReactNode;
//   clickedIcon?: React.ReactNode;
//   nav?: string;
//   visibility: string[];
// }

// interface NavSubItem extends BaseNavItem {
//   nav: string;
// }

// interface NavItem extends BaseNavItem {
//   icon: React.ReactNode;
//   clickedIcon: React.ReactNode;
//   items?: NavSubItem[];
// }

// type CombinedNavItem = NavItem | NavSubItem;

// interface User {
//     name: string;
//     googleProfilePicture?: string;
//     roles: string[];
// }

// // --- Component Props ---
// interface HomepageProps {
//   index: string;
// }

// // --- Constants ---
// const drawerWidth = 250;
// const collapsedDrawerWidth = 72;

// // --- Initial Navigation Data (Typed) ---
// const initialNavPaneList: NavItem[] = [
//   {
//     id: "dashboard",
//     text: "Dashboard",
//     icon: <RiDashboardLine />,
//     clickedIcon: <RiDashboardFill />,
//     nav: "/",
//     visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin"],
//   },
//   {
//     id: "clusters",
//     text: "Clusters",
//     icon: <RiArchiveDrawerLine />,
//     clickedIcon: <RiArchiveDrawerFill />,
//     nav: "/clusters",
//     visibility: ["cluster_owner", "application_owner", "idp_admin"],
//   },
//   {
//     id: "applications",
//     text: "Applications",
//     icon: <RiArchiveStackLine />,
//     clickedIcon: <RiArchiveStackFill />,
//     nav: "/applications",
//     visibility: ["cluster_owner", "application_owner", "idp_admin", "developer"],
//   },
//   {
//     id: "services",
//     text: "Services",
//     icon: <RiBubbleChartLine />,
//     clickedIcon: <RiBubbleChartFill />,
//     nav: "/services",
//     visibility: ["application_owner", "idp_admin", "developer"],
//   },
//   {
//     id: "aisolutions",
//     text: "AI Solutions",
//     icon: <RiChatVoiceLine/>,
//     clickedIcon: <RiChatVoiceFill />,
//     nav: "",
//     visibility: ["cluster_owner", "application_owner", "idp_admin", "developer", "infrastructure_admin"],
//     items:[
//       { id: "aisolutions-aiagent", text: "AI Agent", nav: "/aisolutions/aiagent", visibility: ["infrastructure_admin", "idp_admin"] },
//       { id: "aisolutions-rag", text: "RAG", nav: "/aisolutions/rag", visibility: ["infrastructure_admin", "idp_admin"] }
//     ],
//   },
//   {
//     id: "integrations",
//     text: "Integrations",
//     icon: <RiGitMergeLine/>,
//     clickedIcon: <RiGitMergeFill />,
//     nav: "/integrations/integrations",
//     visibility: ["idp_admin"],
//   },
//   {
//     id: "user-management",
//     text: "User Management",
//     icon: <RiGroupLine />,
//     clickedIcon: <RiGroupFill />,
//     nav: "/user-management",
//     visibility: ["idp_admin"],
//   },
//   {
//     id: "requests",
//     text: "Requests",
//     icon: <RiCornerDownRightLine />,
//     clickedIcon: <RiCornerDownRightLine />, // Make sure this icon exists or adjust
//     nav: "",
//     visibility: ["infrastructure_admin", "application_owner", "idp_admin"],
//     items: [
//       { id: "requests-cluster", text: "Clusters", icon: <RiArchiveDrawerLine />, clickedIcon: <RiArchiveDrawerFill />, nav: "/requests/clusters", visibility: ["infrastructure_admin", "idp_admin"] },
//       { id: "requests-application", text: "Applications", icon: <RiArchiveStackLine />, clickedIcon: <RiArchiveStackFill />, nav: "/requests/applications", visibility: ["infrastructure_admin", "idp_admin"] },
//       { id: "requests-service", text: "Services", icon: <RiBubbleChartLine />, clickedIcon: <RiBubbleChartFill />, nav: "/requests/services", visibility: ["application_owner", "idp_admin"] },
//     ],
//   },
// ];


// // --- Component Implementation ---
// const MainDrawer: React.FC<HomepageProps> = ({ index }) => {
//   const { user, logoutUser } = useAuth() as { user: User | null, logoutUser: () => void };
//   const theme = useTheme();
//   const navigate = useNavigate();

//   const [isDrawerOpen, setIsDrawerOpen] = useState(true);
//   const [selectedMenu, setSelectedMenu] = useState<string>(index);

//   // Filter and map navPaneList based on user roles (Memoized) - CORRECTED
//   const visibleNavPaneList: NavItem[] = useMemo(() => {
//       if (!user?.roles) return [];
//       const userRoles = user.roles;

//       let filteredList = initialNavPaneList.filter((element: NavItem) =>
//           element.visibility.some((e: string) => userRoles.includes(e))
//       );

//       return filteredList.map((element: NavItem): NavItem => {
//           let processedSubItems: NavSubItem[] | undefined = undefined;

//           // Check if items exist and are not empty initially
//           if (element.items && element.items.length > 0) {
//               // Filter sub-items based on visibility
//               const filteredSubItems = element.items.filter((el: NavSubItem) =>
//                   el.visibility.some((e: string) => userRoles.includes(e))
//               );
//               // Assign only if the filtered array is not empty
//               if (filteredSubItems.length > 0) {
//                   processedSubItems = filteredSubItems;
//               }
//           }
//           // Return the element with correctly filtered/undefined sub-items
//           return {
//               ...element,
//               items: processedSubItems,
//           };
//       });
//   }, [user?.roles]); // Dependency array includes user?.roles


//   const [nestedOpen, setNestedOpen] = useState<Record<string, boolean>>(() => {
//     if (index.includes("-")) {
//       const parentId = index.split("-")[0];
//       const parentItem = visibleNavPaneList.find((item: NavItem) => item.id === parentId);
//       if (parentItem?.items && parentItem.items.length > 0) {
//           return { [parentId]: true };
//       }
//     }
//     return {};
//   });

//   const handleNestedClick = (name: string) => {
//     if (isDrawerOpen) {
//       setNestedOpen((prev: Record<string, boolean>) => ({ ...prev, [name]: !prev[name] }));
//     }
//   };

//   const handleMenuSelect = (key: string) => {
//       setSelectedMenu(key);

//       const selectedItem = visibleNavPaneList
//           .flatMap((m: NavItem): CombinedNavItem[] =>
//               m.items ? [m, ...m.items] : [m]
//           )
//           .find((i: CombinedNavItem) => i.id === key);

//       // Check if the selected item is a parent item with actual items after filtering
//       const isParentItem = selectedItem && 'items' in selectedItem && selectedItem.items && selectedItem.items.length > 0;

//       if (isParentItem && isDrawerOpen) {
//           handleNestedClick(selectedItem.id);
//       }
//   };


//   const handleNavigate = (navPath?: string) => {
//       if (navPath) {
//           navigate(navPath);
//       }
//   };

//   const toggleDrawer = () => {
//     const newState = !isDrawerOpen;
//     setIsDrawerOpen(newState);
//     if (!newState) {
//         setNestedOpen({});
//     }
//   };

//   const isSelected = (menuItem: NavItem): boolean => {
//     if (menuItem.id === selectedMenu) return true;
//     // Check if any *visible* sub-item is selected
//     if (menuItem.items?.some((item: NavSubItem) => item.id === selectedMenu)) {
//       return true;
//     }
//     return false;
//   };


//   return (
//     // JSX remains the same as the previous correct version
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: isDrawerOpen ? drawerWidth : collapsedDrawerWidth,
//         flexShrink: 0,
//         height: "100%",
//         whiteSpace: 'nowrap',
//         transition: theme.transitions.create('width', {
//           easing: theme.transitions.easing.sharp,
//           duration: isDrawerOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
//         }),
//         [`& .MuiDrawer-paper`]: {
//           width: isDrawerOpen ? drawerWidth : collapsedDrawerWidth,
//           boxSizing: "border-box",
//           backgroundColor: "black",
//           color: "white",
//           display: "flex",
//           flexDirection: "column",
//           overflowX: 'hidden',
//           transition: theme.transitions.create('width', {
//             easing: theme.transitions.easing.sharp,
//             duration: isDrawerOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
//           }),
//         },
//       }}
//     >
//       {/* --- Top Section --- */}
//       <Box sx={{ px: isDrawerOpen ? 2 : 0, pt: "12px", display: 'flex', flexDirection: 'column' }}>
//          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pl: isDrawerOpen ? 0 : 2.5, mb: isDrawerOpen ? 0 : 1 }}>
//              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexGrow: 1, minWidth: 0 }}>
//                  <img src="/assets/Logo.svg" alt="Logo Icon" style={{ width: "54px", height: "54px", flexShrink: 0 }}/>
//                  {isDrawerOpen && ( <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" noWrap>Faraday</Typography>)}
//              </Box>
//              <IconButton onClick={toggleDrawer} sx={{ color: 'white', mr: isDrawerOpen ? 0 : 0, ml: isDrawerOpen ? 1 : 0 }}>
//                  {isDrawerOpen ? <ChevronLeftIcon /> : <MenuOpenIcon />}
//              </IconButton>
//          </Box>
//         {isDrawerOpen && user && (
//           <>
//             <Stack direction="column" marginTop="-20px">
//               <Avatar src={user.googleProfilePicture} alt={user.name} sx={{ width: "56px", height: "56px", marginLeft: "24px", position: "relative", top: 39, border: "3px solid black" }} />
//               <Box sx={{ backgroundColor: "#212121", borderRadius: "8px", padding: "10px", margin: "20px", display: "flex", flexDirection: "column", opacity: isDrawerOpen ? 1 : 0, transition: theme.transitions.create('opacity', { duration: theme.transitions.duration.leavingScreen }) }}>
//                 <Typography fontFamily="Gilroy-Bold" fontSize="16px" marginTop="10px" marginLeft="4px" noWrap>{user.name}</Typography>
//                 <Grid container gap={0.5} mt={0.5}>
//                   {user.roles?.map((e: string) => ( <Grid item key={e}><Paper elevation={3} sx={{ borderRadius: 10, backgroundColor: "#555" }}><Box px={1} py={0.2}><Typography fontSize="10px" fontFamily="Gilroy-Regular" color="#fff" noWrap>{nameRoleObj[e] || e}</Typography></Box></Paper></Grid> ))}
//                 </Grid>
//               </Box>
//             </Stack>
//             <Divider color="#181818" sx={{ mt: "8px", mb: "8px", mx: "16px" }} />
//           </>
//         )}
//          {!isDrawerOpen && user && (
//             <>
//                 <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}><Avatar src={user.googleProfilePicture} alt={user.name} sx={{ width: 40, height: 40 }}/></Box>
//                  <Divider color="#181818" sx={{ my: "8px", mx: "16px" }} />
//             </>
//          )}
//       </Box>

//       {/* --- Scrollable Navigation List --- */}
//       <Box sx={{ overflowY: "auto", overflowX: 'hidden', flex: 1 }}>
//         <List sx={{ px: "8px", mx: "8px" }}>
//           {visibleNavPaneList.map((menu: NavItem) => {
//             const currentSelected = isSelected(menu);
//             return (
//             <React.Fragment key={menu.id}>
//               <ListItem component="div" onClick={() => { handleMenuSelect(menu.id); if (!menu.items || !isDrawerOpen) { handleNavigate(menu.nav); } }}
//                 sx={{ cursor: "pointer", borderRadius: "8px", mb: 0.5, backgroundColor: currentSelected ? "#fff" : "transparent", color: currentSelected ? "#000" : "#fff", '&:hover': { backgroundColor: currentSelected ? '#eee' : '#333' }, justifyContent: isDrawerOpen ? 'initial' : 'center', px: isDrawerOpen ? 2 : 2.5 }}>
//                 <ListItemIcon sx={{ color: currentSelected ? "#000" : "#fff", minWidth: 0, mr: isDrawerOpen ? 2 : 'auto', justifyContent: 'center', fontSize: '1.5rem' }}>
//                   {currentSelected ? menu.clickedIcon : menu.icon}
//                 </ListItemIcon>
//                 {isDrawerOpen && ( <ListItemText sx={{ opacity: isDrawerOpen ? 1 : 0, transition: 'opacity 0.2s' }}><Typography fontFamily="Gilroy-Bold" fontSize="14px" noWrap>{menu.text}</Typography></ListItemText> )}
//                 {isDrawerOpen && menu.items && menu.items.length > 0 && ( nestedOpen[menu.id] ? <ExpandLess sx={{ color: currentSelected ? "#000" : "#fff" }} /> : <ExpandMore sx={{ color: currentSelected ? "#000" : "#fff" }} /> )}
//               </ListItem>
//               {isDrawerOpen && menu.items && menu.items.length > 0 && (
//                 <Collapse in={nestedOpen[menu.id]} timeout="auto" unmountOnExit>
//                   <List sx={{ pl: 4, py: 0 }}>
//                     {menu.items.map((item: NavSubItem) => {
//                        const isNestedSelected = item.id === selectedMenu;
//                        return (
//                       <ListItem key={item.id} component="div" onClick={(e) => { e.stopPropagation(); handleMenuSelect(item.id); handleNavigate(item.nav); }}
//                         sx={{ cursor: "pointer", borderRadius: "8px", py: 0.8, mb: 0.5, backgroundColor: isNestedSelected ? "#fff" : "transparent", color: isNestedSelected ? "#000" : "#fff", '&:hover': { backgroundColor: isNestedSelected ? '#eee' : '#333' } }}>
//                         <ListItemText><Typography fontFamily="Gilroy-Bold" fontSize="14px" noWrap>{item.text}</Typography></ListItemText>
//                       </ListItem>
//                     )})}
//                   </List>
//                 </Collapse>
//               )}
//             </React.Fragment>
//           )})}
//         </List>
//       </Box>

//       {/* --- Sign Out Button --- */}
//       <Box sx={{ mt: "auto", p: isDrawerOpen ? 2 : 0, display: 'flex', justifyContent: isDrawerOpen ? 'flex-start' : 'center', alignItems: 'center' }}>
//           {isDrawerOpen && <Divider sx={{ bgcolor: "#212121", width: '100%', mb: 1 }} /> }
//           <Button fullWidth={isDrawerOpen} variant="text" sx={{ backgroundColor: "transparent", color: "#aaa", fontWeight: "bold", display: "flex", justifyContent: isDrawerOpen ? "flex-start" : "center", alignItems: "center", minWidth: 'auto', px: isDrawerOpen ? 2 : 2.5, py: 1.5, "&:hover": { backgroundColor: "#212121", color: "white" ,}, textTransform: "none", borderRadius: "8px" }}
//               onClick={() => { logoutUser(); navigate("/login"); }} title="Sign Out">
//               <RiLogoutCircleRLine size={20} />
//               {isDrawerOpen && ( <Typography fontFamily="Gilroy-Regular" fontSize="14px" ml="12px" color="inherit" noWrap>Sign Out</Typography> )}
//           </Button>
//       </Box>
//     </Drawer>
//   );
// };
// export default MainDrawer;

// import React, { useState, useMemo } from "react"; // Import useMemo
// import { useNavigate } from "react-router-dom";
// import {
//   Toolbar,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   Typography,
//   Divider,
//   Avatar,
//   Stack,
//   Button,
//   Collapse,
//   Grid,
//   Paper,
//   IconButton,
//   useTheme,
// } from "@mui/material";
// import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
// import { RiLogoutCircleRLine } from "react-icons/ri";
// import { RiDashboardLine } from "react-icons/ri";
// import { RiArchiveDrawerLine } from "react-icons/ri";
// import { RiGroupLine } from "react-icons/ri";
// import { RiArchiveStackLine } from "react-icons/ri";
// import { RiBubbleChartLine } from "react-icons/ri";
// import { RiCornerDownRightLine } from "react-icons/ri";
// import { RiChatVoiceLine,RiChatVoiceFill} from 'react-icons/ri';
// import { RiGroupFill } from "react-icons/ri";
// import { RiArchiveDrawerFill } from "react-icons/ri";
// import { RiDashboardFill } from "react-icons/ri";
// import { RiArchiveStackFill } from "react-icons/ri";
// import { RiBubbleChartFill } from "react-icons/ri";
// import {RiGitMergeLine, RiGitMergeFill} from "react-icons/ri"
// import { useAuth } from "../helpers/AuthProvider"; // Assuming AuthProvider provides user type

// import { nameRoleObj } from "../helpers/RoleHelper"; // Assuming RoleHelper exports this mapping
// import { ExpandLess, ExpandMore, Visibility } from "@mui/icons-material";
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import MenuOpenIcon from '@mui/icons-material/MenuOpen';
// // Removed unused queryGraphql import, add back if needed elsewhere
// // import queryGraphql from "../helpers/ApiInterface";

// // --- Type Definitions ---
// interface BaseNavItem {
//   id: string;
//   text: string;
//   icon?: React.ReactNode;
//   clickedIcon?: React.ReactNode;
//   nav?: string; // Nav is optional at base level
//   visibility: string[];
// }

// interface NavSubItem extends BaseNavItem {
//   nav: string; // Sub-items require nav
//   // Sub-items might optionally have icons too, adjust if needed
// }

// interface NavItem extends BaseNavItem {
//   icon: React.ReactNode; // Main items require icons
//   clickedIcon: React.ReactNode;
//   items?: NavSubItem[]; // Nested items are of type NavSubItem
// }

// // Type for the combined list after flatMap
// type CombinedNavItem = NavItem | NavSubItem;

// // Type for the user object from useAuth - replace with actual type if available
// interface User {
//     name: string;
//     googleProfilePicture?: string;
//     roles: string[];
// }

// // --- Component Props ---
// interface HomepageProps {
//   index: string; // The initially selected menu item ID
// }

// // --- Constants ---
// const drawerWidth = 250;
// const collapsedDrawerWidth = 72;

// // --- Initial Navigation Data (Typed) ---
// const initialNavPaneList: NavItem[] = [
//   {
//     id: "dashboard",
//     text: "Dashboard",
//     icon: <RiDashboardLine />,
//     clickedIcon: <RiDashboardFill />,
//     nav: "/",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//   },
//   {
//     id: "clusters",
//     text: "Clusters",
//     icon: <RiArchiveDrawerLine />,
//     clickedIcon: <RiArchiveDrawerFill />,
//     nav: "/clusters",
//     visibility: ["cluster_owner", "application_owner", "idp_admin"],
//   },
//   {
//     id: "applications",
//     text: "Applications",
//     icon: <RiArchiveStackLine />,
//     clickedIcon: <RiArchiveStackFill />,
//     nav: "/applications",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//     ],
//   },
//   {
//     id: "services",
//     text: "Services",
//     icon: <RiBubbleChartLine />,
//     clickedIcon: <RiBubbleChartFill />,
//     nav: "/services",
//     visibility: ["application_owner", "idp_admin", "developer"],
//   },
//   {
//     id: "aisolutions",
//     text: "AI Solutions",
//     icon: <RiChatVoiceLine/>,
//     clickedIcon: <RiChatVoiceFill />,
//     nav: "", // No top-level navigation if it has items
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//     items:[
//       {
//         id: "aisolutions-aiagent",
//         text: "AI Agent",
//         nav: "/aisolutions/aiagent",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "aisolutions-rag",
//         text: "RAG",
//         nav: "/aisolutions/rag",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       }
//     ],
//   },
//     {
//     id: "integrations",
//     text: "Integrations",
//     icon: <RiGitMergeLine/>,
//     clickedIcon: <RiGitMergeFill />,
//     nav: "/integrations/integrations",
//     visibility: [
//       "idp_admin",
//     ],
//   },
//   {
//     id: "user-management",
//     text: "User Management",
//     icon: <RiGroupLine />,
//     clickedIcon: <RiGroupFill />,
//     nav: "/user-management",
//     visibility: ["idp_admin"],
//   },
//   {
//     id: "requests",
//     text: "Requests",
//     icon: <RiCornerDownRightLine />,
//     clickedIcon: <RiCornerDownRightLine />, // Ensure clickedIcon is provided
//     nav: "", // No top-level navigation if it has items
//     visibility: ["infrastructure_admin", "application_owner", "idp_admin"],
//     items: [
//       {
//         id: "requests-cluster",
//         text: "Clusters",
//         icon: <RiArchiveDrawerLine />,
//         clickedIcon: <RiArchiveDrawerFill />,
//         nav: "/requests/clusters",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-application",
//         text: "Applications",
//         icon: <RiArchiveStackLine />,
//         clickedIcon: <RiArchiveStackFill />,
//         nav: "/requests/applications",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-service",
//         text: "Services",
//         icon: <RiBubbleChartLine />,
//         clickedIcon: <RiBubbleChartFill />,
//         nav: "/requests/services",
//         visibility: ["application_owner", "idp_admin"],
//       },
//     ],
//   },
// ];


// // --- Component Implementation ---
// const MainDrawer: React.FC<HomepageProps> = ({ index }) => {
//   const { user, logoutUser } = useAuth() as { user: User | null, logoutUser: () => void }; // Cast useAuth result
//   const theme = useTheme();
//   const navigate = useNavigate();

//   const [isDrawerOpen, setIsDrawerOpen] = useState(true);
//   const [selectedMenu, setSelectedMenu] = useState<string>(index); // Explicitly type state

//   // Filter and map navPaneList based on user roles (Memoized)
//   const visibleNavPaneList: NavItem[] = useMemo(() => {
//       if (!user?.roles) return []; // Return empty if no roles
//       const userRoles = user.roles; // Cache roles for checks

//       let filteredList = initialNavPaneList.filter((element: NavItem) =>
//           element.visibility.some((e: string) => userRoles.includes(e))
//       );

//       return filteredList.map((element: NavItem): NavItem => ({ // Ensure map returns NavItem
//           ...element,
//           items: element.items
//               ?.filter((el: NavSubItem) =>
//                   el.visibility.some((e: string) => userRoles.includes(e))
//               )
//               // Ensure items array is not empty after filtering, otherwise set to undefined
//               .filter(items => items.length > 0).length > 0
//                   ? element.items?.filter((el: NavSubItem) => el.visibility.some((e: string) => userRoles.includes(e)))
//                   : undefined,
//       }));
//   }, [user?.roles]);


//   const [nestedOpen, setNestedOpen] = useState<Record<string, boolean>>(() => {
//     // Initialize nestedOpen based on the initial index
//     if (index.includes("-")) {
//       const parentId = index.split("-")[0];
//       // Explicitly type 'item' here
//       const parentItem = visibleNavPaneList.find((item: NavItem) => item.id === parentId);
//       // Ensure parentItem and its items exist
//       if (parentItem?.items && parentItem.items.length > 0) {
//           return { [parentId]: true };
//       }
//     }
//     return {};
//   });

//   const handleNestedClick = (name: string) => {
//     if (isDrawerOpen) {
//       setNestedOpen((prev: Record<string, boolean>) => ({ ...prev, [name]: !prev[name] }));
//     }
//   };

//   const handleMenuSelect = (key: string) => {
//       setSelectedMenu(key);

//       // Explicitly type 'm' and 'i' here
//       const selectedItem = visibleNavPaneList
//           .flatMap((m: NavItem): CombinedNavItem[] => // Type 'm' and return type
//               m.items ? [m, ...m.items] : [m]
//           )
//           .find((i: CombinedNavItem) => i.id === key); // Type 'i'

//       // Check if the selected item is a parent item (has 'items' property)
//       const isParentItem = selectedItem && 'items' in selectedItem && selectedItem.items && selectedItem.items.length > 0;

//       if (isParentItem && isDrawerOpen) {
//           handleNestedClick(selectedItem.id); // Toggle nested list if parent is clicked when open
//       }
//       // No automatic toggling when drawer is closed or if it's not a parent item
//   };


//   const handleNavigate = (navPath?: string) => { // Type navPath as string | undefined
//       if (navPath) {
//           navigate(navPath);
//       }
//   };

//   const toggleDrawer = () => {
//     const newState = !isDrawerOpen;
//     setIsDrawerOpen(newState);
//     if (!newState) { // If closing
//         setNestedOpen({});
//     }
//   };

//   const isSelected = (menuItem: NavItem): boolean => {
//     if (menuItem.id === selectedMenu) return true;
//     if (menuItem.items?.some((item: NavSubItem) => item.id === selectedMenu)) {
//       return true; // Highlight parent if a child is selected
//     }
//     return false;
//   };


//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: isDrawerOpen ? drawerWidth : collapsedDrawerWidth,
//         flexShrink: 0,
//         height: "100%",
//         whiteSpace: 'nowrap',
//         transition: theme.transitions.create('width', {
//           easing: theme.transitions.easing.sharp,
//           duration: isDrawerOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
//         }),
//         [`& .MuiDrawer-paper`]: {
//           width: isDrawerOpen ? drawerWidth : collapsedDrawerWidth,
//           boxSizing: "border-box",
//           backgroundColor: "black",
//           color: "white",
//           display: "flex",
//           flexDirection: "column",
//           overflowX: 'hidden',
//           transition: theme.transitions.create('width', {
//             easing: theme.transitions.easing.sharp,
//             duration: isDrawerOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
//           }),
//         },
//       }}
//     >
//       {/* --- Top Section (Logo, User, Toggle Button) --- */}
//       <Box sx={{ px: isDrawerOpen ? 2 : 0, pt: "12px", display: 'flex', flexDirection: 'column' }}>
//          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pl: isDrawerOpen ? 0 : 2.5, mb: isDrawerOpen ? 0 : 1 }}>
//              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexGrow: 1, minWidth: 0 /* Prevent flex item from growing too large */ }}>
//                  <img
//                      src="/assets/Logo.svg"
//                      alt="Logo Icon"
//                      style={{ width: "54px", height: "54px", flexShrink: 0 }}
//                  />
//                  {isDrawerOpen && (
//                      <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" noWrap>
//                          Faraday
//                      </Typography>
//                  )}
//              </Box>
//              <IconButton
//                  onClick={toggleDrawer}
//                  sx={{ color: 'white', mr: isDrawerOpen ? 0 : 0, ml: isDrawerOpen ? 1 : 0 }}
//              >
//                  {isDrawerOpen ? <ChevronLeftIcon /> : <MenuOpenIcon />}
//              </IconButton>
//          </Box>

//         {isDrawerOpen && user && (
//           <>
//             <Stack direction="column" marginTop="-20px">
//               <Avatar
//                 src={user.googleProfilePicture}
//                 alt={user.name} // Use user name for alt text
//                 sx={{
//                   width: "56px",
//                   height: "56px",
//                   marginLeft: "24px",
//                   position: "relative",
//                   top: 39,
//                   border: "3px solid black",
//                 }}
//               />
//               <Box
//                 sx={{
//                   backgroundColor: "#212121",
//                   borderRadius: "8px",
//                   padding: "10px",
//                   margin: "20px",
//                   display: "flex",
//                   flexDirection: "column",
//                   opacity: isDrawerOpen ? 1 : 0,
//                   transition: theme.transitions.create('opacity', { duration: theme.transitions.duration.leavingScreen }),
//                 }}
//               >
//                 <Typography fontFamily="Gilroy-Bold" fontSize="16px" marginTop="10px" marginLeft="4px" noWrap>
//                   {user.name}
//                 </Typography>
//                 <Grid container gap={0.5} mt={0.5}>
//                   {user.roles?.map((e: string) => (
//                     <Grid item key={e}>
//                       <Paper
//                         elevation={3}
//                         sx={{ borderRadius: 10, backgroundColor: "#555" }}
//                       >
//                         <Box px={1} py={0.2}>
//                            <Typography fontSize="10px" fontFamily="Gilroy-Regular" color="#fff" noWrap>
//                               {nameRoleObj[e] || e}
//                            </Typography>
//                         </Box>
//                       </Paper>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Box>
//             </Stack>
//             <Divider color="#181818" sx={{ mt: "8px", mb: "8px", mx: "16px" }} />
//           </>
//         )}
//          {!isDrawerOpen && user && (
//             <>
//                 <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
//                     <Avatar src={user.googleProfilePicture} alt={user.name} sx={{ width: 40, height: 40 }}/>
//                 </Box>
//                  <Divider color="#181818" sx={{ my: "8px", mx: "16px" }} />
//             </>
//          )}
//       </Box>

//       {/* --- Scrollable Navigation List --- */}
//       <Box sx={{ overflowY: "auto", overflowX: 'hidden', flex: 1 }}>
//         <List sx={{ px: "8px", mx: "8px" }}>
//           {/* Explicitly type 'menu' here */}
//           {visibleNavPaneList.map((menu: NavItem) => {
//             const currentSelected = isSelected(menu);
//             return (
//             <React.Fragment key={menu.id}>
//               <ListItem
//                 component="div"
//                 onClick={() => {
//                    handleMenuSelect(menu.id);
//                    // Only navigate if it's NOT a parent item meant to toggle the submenu,
//                    // or if the drawer is collapsed (where clicking the icon should navigate)
//                    if (!menu.items || !isDrawerOpen) {
//                        handleNavigate(menu.nav);
//                    }
//                 }}
//                 sx={{
//                   cursor: "pointer", borderRadius: "8px", mb: 0.5,
//                   backgroundColor: currentSelected ? "#fff" : "transparent",
//                   color: currentSelected ? "#000" : "#fff",
//                   '&:hover': { backgroundColor: currentSelected ? '#eee' : '#333' },
//                   justifyContent: isDrawerOpen ? 'initial' : 'center',
//                   px: isDrawerOpen ? 2 : 2.5,
//                 }}
//               >
//                 <ListItemIcon
//                     sx={{
//                         color: currentSelected ? "#000" : "#fff", minWidth: 0,
//                         mr: isDrawerOpen ? 2 : 'auto', justifyContent: 'center',
//                         fontSize: '1.5rem'
//                     }}
//                 >
//                   {currentSelected ? menu.clickedIcon : menu.icon}
//                 </ListItemIcon>
//                 {isDrawerOpen && (
//                     <ListItemText sx={{ opacity: isDrawerOpen ? 1 : 0, transition: 'opacity 0.2s' }}>
//                         <Typography fontFamily="Gilroy-Bold" fontSize="14px" noWrap>{menu.text}</Typography>
//                     </ListItemText>
//                 )}
//                 {isDrawerOpen && menu.items && menu.items.length > 0 && (
//                      nestedOpen[menu.id] ? <ExpandLess sx={{ color: currentSelected ? "#000" : "#fff" }} /> : <ExpandMore sx={{ color: currentSelected ? "#000" : "#fff" }} />
//                 )}
//               </ListItem>

//               {/* Nested Menu Items */}
//               {isDrawerOpen && menu.items && menu.items.length > 0 && (
//                 <Collapse in={nestedOpen[menu.id]} timeout="auto" unmountOnExit>
//                   <List sx={{ pl: 4, py: 0 }}>
//                     {/* Explicitly type 'item' here */}
//                     {menu.items.map((item: NavSubItem) => {
//                        const isNestedSelected = item.id === selectedMenu;
//                        return (
//                       <ListItem
//                         key={item.id}
//                         component="div"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleMenuSelect(item.id);
//                           handleNavigate(item.nav); // Sub-items always navigate
//                         }}
//                         sx={{
//                           cursor: "pointer", borderRadius: "8px", py: 0.8, mb: 0.5,
//                            backgroundColor: isNestedSelected ? "#fff" : "transparent",
//                            color: isNestedSelected ? "#000" : "#fff",
//                            '&:hover': { backgroundColor: isNestedSelected ? '#eee' : '#333' },
//                         }}
//                       >
//                         {/* Add optional icons for sub-items if desired */}
//                         {/* {item.icon && <ListItemIcon sx={{ color: isNestedSelected ? "#000" : "#fff", minWidth: 30, mr: 1 }}>
//                              { isNestedSelected ? item.clickedIcon : item.icon }
//                         </ListItemIcon>} */}
//                         <ListItemText>
//                            <Typography fontFamily="Gilroy-Bold" fontSize="14px" noWrap>{item.text}</Typography>
//                         </ListItemText>
//                       </ListItem>
//                     )})}
//                   </List>
//                 </Collapse>
//               )}
//             </React.Fragment>
//           )})}
//         </List>
//       </Box>

//       {/* --- Static Section - Sign Out Button --- */}
//       <Box sx={{
//           mt: "auto", p: isDrawerOpen ? 2 : 0, display: 'flex',
//           justifyContent: isDrawerOpen ? 'flex-start' : 'center',
//           alignItems: 'center'
//         }}
//       >
//           {isDrawerOpen && <Divider sx={{ bgcolor: "#212121", width: '100%', mb: 1 }} /> }
//           <Button
//               fullWidth={isDrawerOpen}
//               variant="text"
//               sx={{
//                   backgroundColor: "transparent", color: "#aaa", fontWeight: "bold",
//                   display: "flex", justifyContent: isDrawerOpen ? "flex-start" : "center",
//                   alignItems: "center", minWidth: 'auto',
//                   px: isDrawerOpen ? 2 : 2.5, py: 1.5,
//                   "&:hover": { backgroundColor: "#212121", color: "white" ,},
//                   textTransform: "none", borderRadius: "8px",
//               }}
//               onClick={() => {
//                   logoutUser();
//                   navigate("/login");
//               }}
//               title="Sign Out"
//           >
//               <RiLogoutCircleRLine size={20} />
//               {isDrawerOpen && (
//                   <Typography fontFamily="Gilroy-Regular" fontSize="14px" ml="12px" color="inherit" noWrap>
//                       Sign Out
//                   </Typography>
//               )}
//           </Button>
//       </Box>
//     </Drawer>
//   );
// };
// export default MainDrawer;

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Toolbar,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   Typography,
//   Divider,
//   Avatar,
//   Stack,
//   Button,
//   Collapse,
//   Grid,
//   Paper,
//   IconButton, // Import IconButton
//   useTheme,   // Import useTheme for transitions
// } from "@mui/material";
// import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
// import { RiLogoutCircleRLine } from "react-icons/ri";
// import { RiDashboardLine } from "react-icons/ri";
// import { RiArchiveDrawerLine } from "react-icons/ri";
// import { RiGroupLine } from "react-icons/ri";
// import { RiArchiveStackLine } from "react-icons/ri";
// import { RiBubbleChartLine } from "react-icons/ri";
// import { RiCornerDownRightLine } from "react-icons/ri";
// import { RiChatVoiceLine,RiChatVoiceFill} from 'react-icons/ri';
// import { RiGroupFill } from "react-icons/ri";
// import { RiArchiveDrawerFill } from "react-icons/ri";
// import { RiDashboardFill } from "react-icons/ri";
// import { RiArchiveStackFill } from "react-icons/ri";
// import { RiBubbleChartFill } from "react-icons/ri";
// import {RiGitMergeLine, RiGitMergeFill} from "react-icons/ri"
// import { useAuth } from "../helpers/AuthProvider";

// import { nameRoleObj } from "../helpers/RoleHelper";
// import { ExpandLess, ExpandMore, Visibility } from "@mui/icons-material";
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'; // Icon for collapse
// import MenuOpenIcon from '@mui/icons-material/MenuOpen';       // Icon for expand
// import queryGraphql from "../helpers/ApiInterface";

// const drawerWidth = 250;
// const collapsedDrawerWidth = 72; // Width when collapsed (adjust as needed)

// let navPaneList: any = [
//   {
//     id: "dashboard",
//     text: "Dashboard",
//     icon: <RiDashboardLine />,
//     clickedIcon: <RiDashboardFill />,
//     nav: "/",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//   },
//   {
//     id: "clusters",
//     text: "Clusters",
//     icon: <RiArchiveDrawerLine />,
//     clickedIcon: <RiArchiveDrawerFill />,
//     nav: "/clusters",
//     visibility: ["cluster_owner", "application_owner", "idp_admin"],
//   },
//   {
//     id: "applications",
//     text: "Applications",
//     icon: <RiArchiveStackLine />,
//     clickedIcon: <RiArchiveStackFill />,
//     nav: "/applications",
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//     ],
//   },
//   {
//     id: "services",
//     text: "Services",
//     icon: <RiBubbleChartLine />,
//     clickedIcon: <RiBubbleChartFill />,
//     nav: "/services",
//     visibility: ["application_owner", "idp_admin", "developer"],
//   },
//   {
//     id: "aisolutions",
//     text: "AI Solutions",
//     icon: <RiChatVoiceLine/>,
//     clickedIcon: <RiChatVoiceFill />,
//     nav: "", // No top-level navigation if it has items
//     visibility: [
//       "cluster_owner",
//       "application_owner",
//       "idp_admin",
//       "developer",
//       "infrastructure_admin",
//     ],
//     items:[
//       {
//         id: "aisolutions-aiagent",
//         text: "AI Agent",
//         // icon: <SomeIcon />, // Optional: Add icons for nested items if needed
//         // clickedIcon: <SomeFilledIcon />,
//         nav: "/aisolutions/aiagent",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "aisolutions-rag",
//         text: "RAG",
//          // icon: <SomeIcon />,
//         // clickedIcon: <SomeFilledIcon />,
//         nav: "/aisolutions/rag",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       }
//     ],
//   },
//   {
//     id: "integrations",
//     text: "Integrations",
//     icon: <RiGitMergeLine/>,
//     clickedIcon: <RiGitMergeFill />,
//     nav: "/integrations/integrations",
//     visibility: [
//       "idp_admin",
//     ],
//   },
//   {
//     id: "user-management",
//     text: "User Management",
//     icon: <RiGroupLine />,
//     clickedIcon: <RiGroupFill />,
//     nav: "/user-management",
//     visibility: ["idp_admin"],
//   },
//   {
//     id: "requests",
//     text: "Requests",
//     icon: <RiCornerDownRightLine />,
//     clickedIcon: <RiCornerDownRightLine />,
//     nav: "", // No top-level navigation if it has items
//     visibility: ["infrastructure_admin", "application_owner", "idp_admin"],
//     items: [
//       {
//         id: "requests-cluster",
//         text: "Clusters",
//         icon: <RiArchiveDrawerLine />, // Keep icons consistent if possible
//         clickedIcon: <RiArchiveDrawerFill />,
//         nav: "/requests/clusters",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-application",
//         text: "Applications",
//         icon: <RiArchiveStackLine />,
//         clickedIcon: <RiArchiveStackFill />,
//         nav: "/requests/applications",
//         visibility: ["infrastructure_admin", "idp_admin"],
//       },
//       {
//         id: "requests-service",
//         text: "Services",
//         icon: <RiBubbleChartLine />,
//         clickedIcon: <RiBubbleChartFill />,
//         nav: "/requests/services",
//         visibility: ["application_owner", "idp_admin"],
//       },
//     ],
//   },
// ];

// interface HomepageProps {
//   index: string;
// }

// const MainDrawer: React.FC<HomepageProps> = ({ index }) => {
//   const { user, logoutUser } = useAuth();
//   const theme = useTheme(); // Get theme for transitions
//   const navigate = useNavigate();

//   // State for drawer open/close
//   const [isDrawerOpen, setIsDrawerOpen] = useState(true);

//   // Filter and map navPaneList based on user roles (consider memoization if performance becomes an issue)
//   const visibleNavPaneList = React.useMemo(() => {
//       let filteredList = navPaneList.filter((element: any) => {
//           return element.visibility.some((e: any) => user?.roles.includes(e));
//       });
//       return filteredList.map((element: any) => {
//           return {
//           ...element,
//           items: element.items?.filter((el: any) => {
//               return el.visibility.some((e: any) => user?.roles.includes(e));
//           }),
//           };
//       });
//   }, [user?.roles]); // Recalculate only when user roles change

//   const [nestedOpen, setNestedOpen] = useState<any>(() => {
//     // Initialize nestedOpen based on the initial index, only if the drawer starts open
//     if (index.includes("-")) {
//       const parentId = index.split("-")[0];
//       // Check if the parent item actually exists and has items after filtering
//       const parentItem = visibleNavPaneList.find(item => item.id === parentId);
//       if (parentItem && parentItem.items && parentItem.items.length > 0) {
//           return { [parentId]: true };
//       }
//     }
//     return {};
//   });

//   const [selectedMenu, setSelectedMenu] = useState(index);

//   const handleNestedClick = (name: any) => {
//     // Only toggle nested if the drawer is open
//     if (isDrawerOpen) {
//       setNestedOpen((prev: any) => ({ ...prev, [name]: !prev[name] }));
//     }
//   };

//   const handleMenuSelect = (key: any) => {
//       setSelectedMenu(key);
//       // If selecting a parent item with children while drawer is closed, keep it closed
//       const selectedItem = visibleNavPaneList.flatMap(m => m.items ? [m, ...m.items] : [m]).find(i => i.id === key);
//       if (selectedItem && selectedItem.items?.length && !isDrawerOpen) {
//           // Don't automatically open nested list if drawer is closed
//       } else if (selectedItem && selectedItem.items?.length && isDrawerOpen) {
//           handleNestedClick(selectedItem.id) // Toggle nested list if parent is clicked when open
//       }
//   };

//   const handleNavigate = (navPath: string | undefined) => {
//       if (navPath) {
//           navigate(navPath);
//       }
//   };

//   // Function to toggle drawer state
//   const toggleDrawer = () => {
//     setIsDrawerOpen(!isDrawerOpen);
//      // If closing the drawer, also close all nested menus
//     if (isDrawerOpen) {
//         setNestedOpen({});
//     }
//   };

//   // Helper function to determine if an item or its child is selected
//   const isSelected = (menuItem: any): boolean => {
//     if (menuItem.id === selectedMenu) return true;
//     if (menuItem.items && menuItem.items.some((item: any) => item.id === selectedMenu)) {
//         // If a child is selected, consider the parent selected for highlighting purposes
//         // especially when collapsed
//         return true;
//     }
//     return false;
//   };


//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: isDrawerOpen ? drawerWidth : collapsedDrawerWidth, // Dynamic width
//         flexShrink: 0,
//         height: "100%",
//         whiteSpace: 'nowrap', // Prevent text wrapping during transition
//         transition: theme.transitions.create('width', { // Smooth transition for width
//           easing: theme.transitions.easing.sharp,
//           duration: isDrawerOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
//         }),
//         [`& .MuiDrawer-paper`]: {
//           width: isDrawerOpen ? drawerWidth : collapsedDrawerWidth, // Dynamic width for paper
//           boxSizing: "border-box",
//           backgroundColor: "black",
//           color: "white",
//           display: "flex",
//           flexDirection: "column",
//           overflowX: 'hidden', // Important to hide content when collapsing
//           transition: theme.transitions.create('width', { // Smooth transition for paper width
//             easing: theme.transitions.easing.sharp,
//             duration: isDrawerOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
//           }),
//         },
//       }}
//     >
//       {/* --- Top Section (Logo, User, Toggle Button) --- */}
//       <Box sx={{ px: isDrawerOpen ? 2 : 0, pt: "12px", display: 'flex', flexDirection: 'column' }}>
//          {/* Logo and Toggle Button Row */}
//          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pl: isDrawerOpen ? 0 : 2.5, mb: isDrawerOpen ? 0 : 1 }}>
//              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexGrow: 1 }}>
//                  <img
//                      src="/assets/Logo.svg"
//                      alt="Logo Icon"
//                      style={{ width: "54px", height: "54px", flexShrink: 0 }}
//                  />
//                  {isDrawerOpen && (
//                      <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" noWrap>
//                          Faraday
//                      </Typography>
//                  )}
//              </Box>
//              {/* Toggle Button - Positioned within the header area */}
//              <IconButton
//                  onClick={toggleDrawer}
//                  sx={{
//                      color: 'white',
//                      // Adjust margin/padding as needed for alignment when collapsed/expanded
//                      mr: isDrawerOpen ? 0 : 0,
//                      ml: isDrawerOpen ? 1 : 0,
//                  }}
//              >
//                  {isDrawerOpen ? <ChevronLeftIcon /> : <MenuOpenIcon />}
//              </IconButton>
//          </Box>

//         {/* User Info Section - Only visible when expanded */}
//         {isDrawerOpen && user && (
//           <>
//             <Stack direction="column" marginTop="-20px">
//               <Avatar
//                 src={user.googleProfilePicture}
//                 alt="User icon"
//                 sx={{
//                   width: "56px",
//                   height: "56px",
//                   marginLeft: "24px",
//                   position: "relative",
//                   top: 39,
//                   border: "3px solid black",
//                 }}
//               />
//               <Box
//                 sx={{
//                   backgroundColor: "#212121",
//                   borderRadius: "8px",
//                   padding: "10px",
//                   margin: "20px", // Keeps the box margin consistent
//                   display: "flex",
//                   flexDirection: "column",
//                   opacity: isDrawerOpen ? 1 : 0, // Fade out content
//                   transition: theme.transitions.create('opacity', { duration: theme.transitions.duration.leavingScreen }),
//                 }}
//               >
//                 <Typography fontFamily="Gilroy-Bold" fontSize="16px" marginTop="10px" marginLeft="4px" noWrap>
//                   {user.name}
//                 </Typography>
//                 <Grid container gap={0.5} mt={0.5}>
//                   {user.roles?.map((e: string) => (
//                     <Grid item key={e}> {/* Added key prop */}
//                       <Paper
//                         elevation={3}
//                         sx={{
//                           borderRadius: 10,
//                           backgroundColor: "#555",
//                           // padding: "4px", // padding applied via Box below
//                         }}
//                       >
//                         <Box px={1} py={0.2}>
//                            <Typography fontSize="10px" fontFamily="Gilroy-Regular" color="#fff" noWrap>
//                               {nameRoleObj[e] || e} {/* Fallback to role key if name not found */}
//                            </Typography>
//                         </Box>
//                       </Paper>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Box>
//             </Stack>
//             <Divider
//                 color="#181818"
//                 sx={{ marginTop: "8px", marginBottom: "8px", mx: "16px" }}
//               />
//           </>
//         )}
//          {/* User Avatar Only Section - Only visible when collapsed */}
//          {!isDrawerOpen && user && (
//             <>
//                 <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
//                     <Avatar src={user.googleProfilePicture} alt="User icon" sx={{ width: 40, height: 40 }}/>
//                 </Box>
//                  <Divider color="#181818" sx={{ my: "8px", mx: "16px" }} />
//             </>
//          )}
//       </Box>

//       {/* --- Scrollable Navigation List --- */}
//       <Box sx={{ overflowY: "auto", overflowX: 'hidden', flex: 1 }}>
//         <List sx={{ px: "8px", mx: "8px" }}>
//           {visibleNavPaneList.map((menu: any) => {
//             const currentSelected = isSelected(menu);
//             return (
//             <React.Fragment key={menu.id}>
//               <ListItem
//                 component="div" // Use div for non-button elements with onClick
//                 onClick={() => {
//                    handleMenuSelect(menu.id);
//                    handleNavigate(menu.nav);
//                   // If it has items and is clicked while open, toggle nested; otherwise handle navigation
//                    if (menu.items?.length > 0 && isDrawerOpen) {
//                         handleNestedClick(menu.id);
//                    }
//                 }}
//                 sx={{
//                   cursor: "pointer",
//                   borderRadius: "8px",
//                   mb: 0.5, // Add some margin between items
//                   backgroundColor: currentSelected ? "#fff" : "transparent", // Highlight based on selection
//                   color: currentSelected ? "#000" : "#fff",
//                   '&:hover': { // Add hover effect
//                        backgroundColor: currentSelected ? '#eee' : '#333',
//                   },
//                   justifyContent: isDrawerOpen ? 'initial' : 'center', // Center items when collapsed
//                   px: isDrawerOpen ? 2 : 2.5, // Adjust padding based on state
//                 }}
//               >
//                 {/* Icon */}
//                 <ListItemIcon
//                     sx={{
//                         color: currentSelected ? "#000" : "#fff", // Icon color matches text
//                         minWidth: 0, // Allow icon to shrink
//                         mr: isDrawerOpen ? 2 : 'auto', // Margin right only when open
//                         justifyContent: 'center',
//                         fontSize: '1.5rem' // Ensure icons have a decent size
//                     }}
//                 >
//                   {currentSelected ? menu.clickedIcon : menu.icon}
//                 </ListItemIcon>

//                 {/* Text Label - Only visible when open */}
//                 {isDrawerOpen && (
//                     <ListItemText sx={{ opacity: isDrawerOpen ? 1 : 0, transition: 'opacity 0.2s' }}>
//                         <Typography fontFamily="Gilroy-Bold" fontSize="14px" noWrap>{menu.text}</Typography>
//                     </ListItemText>
//                 )}

//                 {/* Expand/Collapse Icons - Only visible when open and item has children */}
//                 {isDrawerOpen && menu.items?.length > 0 && (
//                      nestedOpen[menu.id] ? <ExpandLess sx={{ color: currentSelected ? "#000" : "#fff" }} /> : <ExpandMore sx={{ color: currentSelected ? "#000" : "#fff" }} />
//                 )}
//               </ListItem>

//               {/* Nested Menu Items - Only visible when open */}
//               {isDrawerOpen && menu.items?.length > 0 && (
//                 <Collapse in={nestedOpen[menu.id]} timeout="auto" unmountOnExit>
//                   {/* Indent nested list */}
//                   <List sx={{ pl: 4, py: 0 }}>
//                     {menu.items.map((item: any) => {
//                        const isNestedSelected = item.id === selectedMenu;
//                        return (
//                       <ListItem
//                         key={item.id}
//                         component="div"
//                         onClick={(e) => {
//                           e.stopPropagation(); // Prevent parent ListItem onClick from firing
//                           handleMenuSelect(item.id);
//                           handleNavigate(item.nav);
//                         }}
//                         sx={{
//                           cursor: "pointer",
//                           borderRadius: "8px",
//                           py: 0.8, // Adjust vertical padding for nested items
//                           mb: 0.5,
//                            backgroundColor: isNestedSelected ? "#fff" : "transparent",
//                            color: isNestedSelected ? "#000" : "#fff",
//                            '&:hover': {
//                                backgroundColor: isNestedSelected ? '#eee' : '#333',
//                            },
//                         }}
//                       >
//                         {/* Optional: Add icons to nested items if needed */}
//                         {/* <ListItemIcon sx={{ color: isNestedSelected ? "#000" : "#fff", minWidth: 30 }}>
//                              { isNestedSelected ? item.clickedIcon : item.icon }
//                         </ListItemIcon> */}
//                         <ListItemText>
//                            <Typography fontFamily="Gilroy-Bold" fontSize="14px" noWrap>{item.text}</Typography>
//                         </ListItemText>
//                       </ListItem>
//                     )})}
//                   </List>
//                 </Collapse>
//               )}
//             </React.Fragment>
//           )})}
//         </List>
//       </Box>

//       {/* --- Static Section - Sign Out Button --- */}
//       <Box sx={{
//           mt: "auto", // Push to bottom
//           p: isDrawerOpen ? 2 : 0, // Padding for the container
//           display: 'flex',
//           justifyContent: isDrawerOpen ? 'flex-start' : 'center', // Center button icon when collapsed
//           alignItems: 'center'
//         }}
//       >
//           {isDrawerOpen && <Divider sx={{ bgcolor: "#212121", width: '100%', mb: 1 }} /> }
//           <Button
//               fullWidth={isDrawerOpen} // Takes full width only when expanded
//               variant="text"
//               sx={{
//                   backgroundColor: "transparent", // Use transparent bg, rely on hover
//                   color: "#aaa", // Dimmed color for sign out
//                   fontWeight: "bold",
//                   display: "flex",
//                   justifyContent: isDrawerOpen ? "flex-start" : "center", // Align content
//                   alignItems: "center",
//                   minWidth: 'auto', // Allow button to shrink
//                   px: isDrawerOpen ? 2 : 2.5, // Horizontal padding
//                   py: 1.5, // Vertical padding
//                   "&:hover": { backgroundColor: "#212121", color: "white" ,},
//                   textTransform: "none",
//                   //pb: "16px", // Use py instead
//                   //pt: "12px", // Use py instead
//                   //mt: "8px", // Handled by container padding/divider margin
//                   borderRadius: "8px",
//               }}
//               onClick={() => {
//                   logoutUser();
//                   navigate("/login");
//               }}
//               title="Sign Out" // Add title for accessibility, especially when collapsed
//           >
//               <RiLogoutCircleRLine size={20} />
//               {isDrawerOpen && (
//                   <Typography fontFamily="Gilroy-Regular" fontSize="14px" ml="12px" color="inherit" noWrap>
//                       Sign Out
//                   </Typography>
//               )}
//           </Button>
//       </Box>
//     </Drawer>
//   );
// };
// export default MainDrawer;